import React from 'react';
import './ReportView.css';
import FeedbackBar from '../../feedbackBar/FeedbackBar';
import withShipment from '../../../withShipment';
import { userInfoSelector } from '../../../redux/selectors/auth';
import {
  allSessionIdsSelector,
  employeeSummarySelector,
  loadingSelector,
  managerSettingSelector,
  managerSummarySelector,
  reportSelector,
  shortAnalysisSelector,
  summaryBreakdownSelector,
  summarySelector,
} from '../../../redux/selectors/settings';
import {
  clearWeeklyReport,
  getManagerSummary,
  listReport,
  listSessionIds,
  listShortAnalysis,
  saveManagerSetting,
  saveManagerSummary,
  updateManagerBank,
  updateReportField,
} from '../../../redux/actions/settings';
import { listWeeklyReportAudit } from '../../../redux/actions/audit';
import { weeklyReportAuditLogsSelector } from '../../../redux/selectors/audit';

import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Tooltip from '@material-ui/core/Tooltip';
import FilterIcon from '../../global/FilterIcon';
import Chip from '@material-ui/core/Chip';
import DescriptionIcon from '@mui/icons-material/Description';
import {
  Stack,
  IconButton,
  Typography,
  Box,
  FormControlLabel,
  Alert,
} from '@mui/material';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@mui/icons-material/Close';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import {
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
} from '../../../redux/actions/ticketOut';
import { globalPDFPreviewReadySelector } from '../../../redux/selectors/ticketOut';
import { DEFAULT_PDF_ZOOM } from '../../raffle/constants';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { BACK } from '../../reading/masterReading/constants';
import { GetApp } from '@material-ui/icons';
import PrintIcon from '@mui/icons-material/Print';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import CustomToolbar from '../../global/CustomToolbar';
import Utils from '../../Utils/Utils';
import RenderPurchaseOrderPDFPreview from '../../transaction/RenderPurchaseOrderPDFPreview';
import SettingsIcon from '@material-ui/icons/Settings';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ManagerSetting from './ManagerSetting';
import WeeklyReportAuditLog from '../../audit/WeeklyReportAuditLog';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { Grid, CardContent, Paper } from '@mui/material';
import InputAdornment from '@material-ui/core/InputAdornment';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { expenses } from '../../transaction/constants';
import { ATM_TYPES, PDF_COLORS } from './constants';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import TableChartIcon from '@mui/icons-material/TableChart';
import CalculateIcon from '@mui/icons-material/Calculate';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import BarChartIcon from '@mui/icons-material/BarChart';
import EventNoteIcon from '@mui/icons-material/EventNote';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const WEEKLY_TABS = [
  {
    key: 'profit',
    label: 'Cash Flow',
    emoji: '💵',
    Icon: TableChartIcon,
    color: '#16a34a',
  },
  {
    key: 'readings',
    label: 'Readings',
    emoji: '🎰',
    Icon: CalculateIcon,
    color: '#0d9488',
  },
  {
    key: 'expenses',
    label: 'Expenses',
    emoji: '📋',
    Icon: AssignmentIcon,
    color: '#2563eb',
  },
  {
    key: 'closingBalance',
    label: 'Closing Balance',
    emoji: '🏦',
    Icon: AccountBalanceIcon,
    color: '#0891b2',
  },
  {
    key: 'managerLoan',
    label: 'Manager Loan',
    emoji: '📒',
    Icon: StickyNote2Icon,
    color: '#ca8a04',
  },
  {
    key: 'dailyActivity',
    label: 'Activity',
    emoji: '📝',
    Icon: EventNoteIcon,
    color: '#db2777',
  },
  {
    key: 'shortAnalysis',
    label: 'Equation X',
    emoji: '🧮',
    Icon: BarChartIcon,
    color: '#059669',
  },
  {
    key: 'percentages',
    label: 'Percentages',
    emoji: '📊',
    Icon: BarChartIcon,
    color: '#7c3aed',
  },
];

class ReportView extends React.Component {
  constructor(props) {
    super(props);
    const todayHouston = this.getHoustonToday();
    const currentDay = todayHouston.getDay(); // 0=Sun, 1=Mon, 2=Tue

    // Distance to last Tuesday
    const diffToLastTuesday =
      currentDay >= 2 ? currentDay - 2 : 7 - (2 - currentDay);

    const fromDate = new Date(todayHouston);
    fromDate.setDate(todayHouston.getDate() - diffToLastTuesday);

    const toDate = new Date(fromDate);
    toDate.setDate(fromDate.getDate() + 6);

    this.state = {
      feedbackBarOpen: false,
      feedbackMessage: '',
      feedbackStatus: '',
      selectedDay: null,
      fromDate,
      toDate,
      selectedSessionIds: [],
      isDialogOpen: false,
      isCommentDialogOpen: false,
      selectedComment: '',
      editingFields: {
        jpOtherIn: false,
        jpOtherOut: false,
        addBank: false,
        loanIn: false,
        minusBank: false,
        jackpotNotPay: false,
      },
      fieldValues: {},
      showAddExpenseDialog: false,
      newExpense: {
        description: '',
        expenseType: '',
        amount: '',
        comments: '',
      },
      showDeleteDialog: false,
      rowToDelete: null,
      amountInput: '',
      nameInput: '',
      type: true,
      activeATMField: null,
      activeATMValue: '',
      //report
      showPdfViewer: false,
      savedScrollY: 0,
      pdfLoadSuccess: true,
      pdfData: null,
      scale: DEFAULT_PDF_ZOOM,
      isSettings: false,
      showAuditLog: false,
      managerSummary: null,
      editedWeeklyNetProfit: null,
      editMode: false,
      editSummaryMode: false,
      deliveryInputValues: {
        cash: '0',
        managerZelle: '0',
        atmReceipts: '0',
        atmAdv: '0',
      },
      pdfPopperAnchor: null,
      isMobile: window.matchMedia('(max-width: 800px)').matches,
      selectedTab: 'profit',
      atmTransactions: [
        {
          type: 'ATM_CASH' | 'ATM_FROM_PROFIT' | 'ATM_DIDNT_USE' | 'ATM_ADV',
          amount: 0,
          permanent: false,
        },
      ],
    };

    this.pdfBtnRef = React.createRef();
    this.dayRowRef = React.createRef();
  }

  componentDidMount() {
    this.props.listSessionIds(
      this.getChicagoDateFromDate(this.state.fromDate),
      this.getChicagoDateFromDate(this.state.toDate),
      this.props.userInfo.selectedLocationId
    );
    this.props.getManagerSummary({
      locationId: this.props.userInfo?.selectedLocationId,
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.managerSummary !== this.props.managerSummary) {
      const delivery = this.props.managerSummary?.delivery;
      this.setState({
        managerSummary: this.withManagerNameFallback(this.props.managerSummary),
        deliveryInputValues: {
          cash: String(delivery?.cash ?? 0),
          managerZelle: String(delivery?.managerZelle ?? 0),
          atmReceipts: String(delivery?.atmReceipts ?? 0),
          atmAdv: String(delivery?.atmAdv ?? 0),
        },
      });
    }

    // Manager Settings may arrive AFTER managerSummary on first load.
    // If they do and the summary's managerName is still blank, retro-fill
    // it from the setting so the ATM Cash Flow header isn't empty.
    if (
      prevProps.managerSetting !== this.props.managerSetting &&
      this.state.managerSummary &&
      !String(this.state.managerSummary.managerName || '').trim()
    ) {
      const filled = this.withManagerNameFallback(this.state.managerSummary);
      if (filled !== this.state.managerSummary) {
        this.setState({ managerSummary: filled });
      }
    }

    if (prevProps.allSessionIds !== this.props.allSessionIds) {
      this.setState({ selectedSessionIds: this.props.allSessionIds }, () => {
        this.refreshComponent(this.state.selectedSessionIds);
      });
    }

    if (
      !this.arrayEquals(prevProps.PDFPreviewReady, this.props.PDFPreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFPreviewReady,
      });
    }

    // Auto-select first day when report data arrives and no day is selected
    if (
      this.props.report &&
      Object.keys(this.props.report).length > 0 &&
      (!this.state.selectedDay || !this.props.report[this.state.selectedDay]) &&
      prevProps.report !== this.props.report // only fire when report actually changes
    ) {
      const days = Object.keys(this.props.report);
      if (days.length > 0) {
        this.handleDaySelect(days[0]);
        // Scroll the day row into view so the days are at the top
        // and the session ID input is above the fold.
        setTimeout(() => {
          if (this.dayRowRef.current) {
            this.dayRowRef.current.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 100);
      }
    }
  }

  handlePdfPopperToggle = () => {
    this.setState((prev) => ({
      pdfPopperAnchor: prev.pdfPopperAnchor ? null : this.pdfBtnRef.current,
    }));
  };

  handlePdfPopperClose = () => {
    this.setState({ pdfPopperAnchor: null });
  };

  handlePdfOptionSelect = (mode) => {
    this.downloadWeeklyPdf(mode);
    this.setState({ pdfPopperAnchor: null });
  };

  //report

  showPdfErrorMessage = (isFailed) => {
    this.props.resetGlobalPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  closePdfViewer = () => {
    const scrollY = this.state.savedScrollY;
    this.setState({ showPdfViewer: false, pdfData: null }, () => {
      setTimeout(() => {
        const el = document.querySelector('.report-container');
        if (el) el.scrollTop = scrollY;
      }, 200);
    });
  };

  // Invoked by WeeklyReportAuditLog rows that are tied to a specific
  // employee's shift. Opens the shift-report PDF overlay; when it's closed,
  // the audit log view is still mounted underneath (showAuditLog stays true)
  // so the manager lands back where they were.
  handleViewShiftReportFromAudit = ({ userId, locationId, clockId }) => {
    if (!userId || !locationId || !clockId) return;
    this.props.getGlobalPDFPreview(
      { userId, locationId, clockId },
      this.showPdfErrorMessage,
      'previewShiftReport'
    );
    const rc = document.querySelector('.report-container');
    this.setState({
      showPdfViewer: true,
      savedScrollY: rc ? rc.scrollTop : 0,
    });
  };

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const timestamp = date.getTime();
    const fileName = `Shift Report - ${getTodayDate} - ${timestamp}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  //end report

  handleEditClick = (field, value) => {
    this.setState((prevState) => ({
      editingFields: {
        ...prevState.editingFields,
        [field]: true,
      },
      fieldValues: {
        ...prevState.fieldValues,
        [field]: value,
      },
    }));
  };

  handleFieldChange = (field, event) => {
    const value = event.target.value;
    this.setState((prevState) => ({
      fieldValues: {
        ...prevState.fieldValues,
        [field]: value,
      },
    }));
  };

  handleApplyClick = (field) => {
    const { fieldValues } = this.state;
    const newValue = parseFloat(fieldValues[field]) || 0;

    const { report } = this.props;
    const { selectedDay } = this.state;

    const hasReportData = report && Object.keys(report).length > 0;
    const selectedReport = hasReportData ? report[selectedDay] || {} : {};

    const callback = (success, message) => {
      if (!success) {
        this.openFeedbackBar('error', message);
      } else {
        this.setState((prevState) => ({
          editingFields: {
            ...prevState.editingFields,
            [field]: false,
          },
        }));

        this.refreshComponent(this.state.selectedSessionIds);
      }
    };

    this.props.updateReportField(
      selectedReport.sessionIds,
      field,
      newValue,
      this.props.userInfo.selectedLocationId,
      callback
    );
  };

  handleBankBoardUpdate = (amount, nameInput, type) => {
    const { report } = this.props;
    const { selectedDay } = this.state;
    const selectedReport = report[selectedDay] || {};
    const data = {
      sessionIds: selectedReport.sessionIds,
      locationId: this.props.userInfo.selectedLocationId,
      amount: amount,
      nameInput: nameInput,
      employeeName: this.props.userInfo.firstname,
      type: type,
    };

    this.props.updateManagerBank(data, (success, message) => {
      if (!success) {
        this.openFeedbackBar('error', message);
      } else {
        this.refreshComponent(this.state.selectedSessionIds);
      }
    });
  };

  handleNameChange = (e) => {
    this.setState({ nameInput: e.target.value });
  };

  handleAmountChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // numbers only
    this.setState({ amountInput: value });
  };

  handleTypeChange = (e) => {
    this.setState({ type: e.target.value });
  };

  handleApply = () => {
    const { amountInput, type, nameInput } = this.state;
    if (!amountInput || !type || !nameInput) return;

    const amount = parseInt(amountInput, 10);
    this.handleBankBoardUpdate(amount, nameInput, type === 'add');

    this.setState({ amountInput: '', type: '', nameInput: '' });
  };

  handleCommentOpenDialog = (comment) => {
    this.setState({ isCommentDialogOpen: true, selectedComment: comment });
  };

  handleCommentCloseDialog = () => {
    this.setState({ isCommentDialogOpen: false, selectedComment: '' });
  };

  handleDaySelect = (day) => {
    this.setState({ selectedDay: day });
  };

  handleTabSelect = (tabKey) => {
    this.setState({ selectedTab: tabKey });
    if (tabKey === 'shortAnalysis') {
      this.fetchShortAnalysis();
    }
  };

  fetchShortAnalysis = () => {
    const sessionIds = this.state.selectedSessionIds;
    if (!sessionIds || sessionIds.length === 0) return;
    this.props.listShortAnalysis({
      sessionIds,
      locationId: this.props.userInfo.selectedLocationId,
    });
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState({
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    });
  };

  refreshComponent = (sessionIds) => {
    this.props.listReport({
      sessionIds: sessionIds,
      locationId: this.props.userInfo.selectedLocationId,
    });
    // Pre-fetch audit logs for the selected sessions so the toolbar
    // button can show/flash if entries exist. Only fires for users
    // authorized to view the audit log (the backend also enforces this).
    if (this.canViewAuditLog() && sessionIds && sessionIds.length > 0) {
      this.props.listWeeklyReportAudit({
        locationId: this.props.userInfo.selectedLocationId,
        readingSessionIds: sessionIds,
      });
    }
  };

  canViewAuditLog = () => {
    const roles = this.props.userInfo?.authority || [];
    return (
      roles.includes('ROLE_OWNER') ||
      roles.includes('ROLE_MASTER_ADMIN') ||
      roles.includes('ROLE_TECH_ADMIN') ||
      roles.includes('ROLE_MANAGER')
    );
  };

  hasAuditLogForCurrentSessions = () => {
    const logs = this.props.weeklyReportAuditLogs || [];
    const sessionIds = this.state.selectedSessionIds || [];
    if (!logs.length || !sessionIds.length) return false;
    const idSet = new Set(sessionIds.map(String));
    return logs.some((l) => idSet.has(String(l.readingSessionId)));
  };

  dateSelectRow = () => {
    const { selectedDay, selectedTab } = this.state;
    const { report } = this.props;

    const hasReportData = report && Object.keys(report).length > 0;
    const firstAvailableDay = hasReportData ? Object.keys(report)[0] : null;
    const dayToUse = selectedDay || firstAvailableDay;
    const isDayChip =
      dayToUse && dayToUse !== 'MANAGER' && dayToUse !== 'SUMMARY';

    if (!hasReportData) return null; // return nothing while loading

    return (
      <div className="dateselectroww">
        <div className="chip-container">
          {Object.keys(report).map((day) => (
            <div
              key={day}
              className={`chip ${dayToUse === day ? 'chip-selected' : ''}`}
              onClick={() => this.handleDaySelect(day)}
            >
              {day}
            </div>
          ))}

          {this.state.managerSummary && this.userHasATMRole() && (
            <div
              key="MANAGER_SUMMARY"
              className={`chip ${
                dayToUse === 'MANAGER' ? 'chip-selected' : ''
              }`}
              onClick={() => this.handleDaySelect('MANAGER')}
            >
              Manager
            </div>
          )}

          <div
            key="SUMMARY"
            className={`chip ${dayToUse === 'SUMMARY' ? 'chip-selected' : ''}`}
            onClick={() => this.handleDaySelect('SUMMARY')}
          >
            Summary
          </div>
        </div>

        {isDayChip && (
          <div className="weekly-tabs-bar">
            <div className="weekly-tabs-list">
              {WEEKLY_TABS.map((t) => {
                const isActive = selectedTab === t.key;
                return (
                  <div
                    key={t.key}
                    className={`weekly-tab ${
                      isActive ? 'weekly-tab-selected' : ''
                    }`}
                    onClick={() => this.handleTabSelect(t.key)}
                  >
                    <span className="weekly-tab-icon">{t.emoji}</span>
                    <span className="weekly-tab-label">{t.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  };

  // Returns true if the current user is allowed to edit (manager summary
  // + per-day fields) the report for `this.state.fromDate`.
  //
  //  - Mondays: always editable so the prior week's manager summary stays
  //    open for finalization regardless of whether the week was ended.
  //  - ROLE_OWNER: always editable.
  //  - ROLE_MASTER_ADMIN / ROLE_MANAGER: editable for any report whose
  //    fromDate is within the last 14 days (two-week grace window).
  //  - Everyone else (ROLE_SUPERVISOR, ROLE_READING_GUY, …): editable
  //    only while the report falls within the current Tue-anchored week.
  canEditReport = () => {
    const roles = this.props.userInfo?.authority || [];
    const fromDate = this.state.fromDate;
    if (!fromDate) return true;

    const todayHouston = this.getHoustonToday();
    if (todayHouston.getUTCDay() === 1) return true;

    if (roles.includes('ROLE_OWNER')) return true;

    if (roles.includes('ROLE_MASTER_ADMIN') || roles.includes('ROLE_MANAGER')) {
      const twoWeeksAgo = new Date(todayHouston);
      twoWeeksAgo.setDate(todayHouston.getDate() - 14);
      twoWeeksAgo.setHours(0, 0, 0, 0);
      return fromDate >= twoWeeksAgo;
    }

    const currentDay = todayHouston.getDay();
    const diffToLastTuesday =
      currentDay >= 2 ? currentDay - 2 : 7 - (2 - currentDay);
    const thisWeekStart = new Date(todayHouston);
    thisWeekStart.setDate(todayHouston.getDate() - diffToLastTuesday);
    thisWeekStart.setHours(0, 0, 0, 0);
    return fromDate >= thisWeekStart;
  };

  getHoustonToday() {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const parts = formatter.formatToParts(new Date());

    let year, month, day;
    parts.forEach((p) => {
      if (p.type === 'year') year = p.value;
      if (p.type === 'month') month = p.value;
      if (p.type === 'day') day = p.value;
    });

    // Create a Date that represents midnight Houston time
    return new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
  }

  getChicagoDateFromDate(date) {
    // Get the Chicago date parts
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const parts = formatter.formatToParts(date);
    let year, month, day;

    for (const part of parts) {
      switch (part.type) {
        case 'year':
          year = part.value;
          break;
        case 'month':
          month = part.value;
          break;
        case 'day':
          day = part.value;
          break;
        default:
          break;
      }
    }
    // Return only YYYY-MM-DD
    return `${year}-${month}-${day}`;
  }

  applyDateRange = () => {
    const { fromDate, toDate } = this.state;
    const fromDateInChicago = this.getChicagoDateFromDate(fromDate);
    const toDateInChicago = this.getChicagoDateFromDate(toDate);

    this.props.listSessionIds(
      fromDateInChicago,
      toDateInChicago,
      this.props.userInfo.selectedLocationId
    );
    this.clearSessionId();
    this.setState({ isDialogOpen: false });
  };

  handleDialogOpen = () => {
    this.setState({ isDialogOpen: true });
  };

  handleDialogClose = () => {
    this.setState({ isDialogOpen: false });
  };

  clearSessionId = () => {
    this.setState({ selectedSessionIds: [] }, () => {
      this.props.clearWeeklyReport();
    });
  };

  addAdjustmentRow = (type) => {
    const { managerSummary } = this.state;
    const adjustments = { ...managerSummary.adjustments };
    // Added assignedTo here
    adjustments[type].push({
      description: '',
      amount: '',
      isPermanent: false,
      assignedTo: '',
    });
    this.setState({ managerSummary: { ...managerSummary, adjustments } });
  };

  removeAdjustmentRow = (type, index) => {
    const { managerSummary } = this.state;
    const adjustments = { ...managerSummary.adjustments };
    adjustments[type].splice(index, 1);
    this.setState({ managerSummary: { ...managerSummary, adjustments } });
  };

  handleAdjustmentChange = (type, index, field, value) => {
    const { managerSummary } = this.state;

    // 1. Create a shallow copy of the additions/deductions array
    const currentList = [...managerSummary.adjustments[type]];

    // 2. Create a brand new object for the item being changed
    currentList[index] = {
      ...currentList[index],
      [field]: value,
    };

    // 3. Create the new adjustments state object
    const newAdjustments = {
      ...managerSummary.adjustments,
      [type]: currentList,
    };

    // 4. Calculate totals
    const totalAdditions = newAdjustments.additions.reduce(
      (sum, a) => sum + (parseFloat(a.amount) || 0),
      0
    );
    const totalDeductions = newAdjustments.deductions.reduce(
      (sum, d) => sum + (parseFloat(d.amount) || 0),
      0
    );
    const adjustedTotal =
      (managerSummary.remainingProfit || 0) + totalAdditions - totalDeductions;

    // 5. Apply to state
    this.setState({
      managerSummary: {
        ...managerSummary,
        adjustments: {
          ...newAdjustments,
          adjustedTotal,
        },
      },
    });
  };

  handleSaveManagerSummary = () => {
    const { managerSummary } = this.state;

    const { additions, deductions } = managerSummary.adjustments;
    const { otherItems } = managerSummary;

    // Helper function to validate rows
    const validateRows = (rows, typeLabel) => {
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];

        if (!row.assignedTo) {
          this.openFeedbackBar(
            'error',
            `${typeLabel} row #${i + 1}: Please select Assign To.`
          );
          return false;
        }

        if (!row.description || !row.description.trim()) {
          this.openFeedbackBar(
            'error',
            `${typeLabel} row #${i + 1}: Description cannot be empty.`
          );
          return false;
        }

        if (
          row.amount === '' ||
          row.amount === null ||
          row.amount === undefined
        ) {
          this.openFeedbackBar(
            'error',
            `${typeLabel} row #${i + 1}: Amount cannot be empty.`
          );
          return false;
        }

        if (isNaN(parseFloat(row.amount))) {
          this.openFeedbackBar(
            'error',
            `${typeLabel} row #${i + 1}: Amount must be a valid number.`
          );
          return false;
        }
      }

      return true;
    };

    // Validate Additions
    if (!validateRows(additions, 'Addition')) return;

    // Validate Deductions
    if (!validateRows(deductions, 'Deduction')) return;

    // Validate Other Items
    if (!validateRows(otherItems, 'Other')) return;

    // $5 rule: Adjusted Total and Total Delivered must agree within
    // DELIVERY_VS_ADJUSTED_TOLERANCE. A larger gap is almost always a
    // data-entry mistake — saving anyway would lock a real accounting
    // discrepancy into the manager summary, so block the request.
    const { delta } = this.getDeliveryDelta();
    const tol = ReportView.DELIVERY_VS_ADJUSTED_TOLERANCE;
    if (Math.abs(delta) > tol) {
      const comparison = delta > 0 ? 'less than' : 'more than';
      // FeedbackBar.jsx splits messages on the literal "$" (each "$"
      // becomes a line break + a "See logs for more detail" link),
      // so use the fullwidth dollar U+FF04 — it looks like "$" but
      // does NOT trigger that split. Don't change to a literal "$".
      this.openFeedbackBar(
        'error',
        `Total Delivered is ＄${this.fmtMoney2(
          Math.abs(delta)
        )} ${comparison} Adjusted Total. The two must match within ＄${this.fmtMoney2(
          tol
        )} before saving.`
      );
      return;
    }

    // If all validations pass
    const payload = {
      locationId: this.props.userInfo.selectedLocationId,
      sessionId: managerSummary.sessionId,
      managerSummary,
    };

    this.props.saveManagerSummary(payload, (success, message) => {
      if (success) {
        this.openFeedbackBar('success', message);
        this.setState({ editMode: false }); // move it here after success
      } else {
        this.openFeedbackBar('error', message);
      }
    });
  };

  handleAddOther = () => {
    this.setState((prevState) => {
      // 1. Create the new row with ALL required fields
      const newItem = {
        description: '',
        amount: '',
        isPermanent: false,
        assignedTo: '',
      };

      const updatedOtherItems = [
        ...(prevState.managerSummary.otherItems || []),
        newItem,
      ];

      // 2. Recalculate totals immediately
      const delivery = prevState.managerSummary.delivery || {};
      const deliveryTotal =
        (parseFloat(delivery.cash) || 0) +
        (parseFloat(delivery.managerZelle) || 0) +
        (parseFloat(delivery.atmReceipts) || 0);

      const otherTotal = updatedOtherItems.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );

      const totalDelivered = deliveryTotal + otherTotal;

      // 3. Update the state
      return {
        managerSummary: {
          ...prevState.managerSummary,
          otherItems: updatedOtherItems,
          delivery: {
            ...prevState.managerSummary.delivery,
            totalDelivered,
          },
        },
      };
    });
  };

  handleRemoveOther = (index) => {
    this.setState((prevState) => {
      const updatedOtherItems = prevState.managerSummary.otherItems.filter(
        (_, i) => i !== index
      );

      const deliveryTotal =
        (prevState.managerSummary.delivery.cash || 0) +
        (prevState.managerSummary.delivery.managerZelle || 0) +
        (prevState.managerSummary.delivery.atmReceipts || 0) +
        (prevState.managerSummary.delivery.atmAdv || 0);

      const otherTotal = updatedOtherItems.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );

      const totalDelivered = deliveryTotal + otherTotal;

      return {
        managerSummary: {
          ...prevState.managerSummary,
          otherItems: updatedOtherItems,
          delivery: {
            ...prevState.managerSummary.delivery,
            totalDelivered,
          },
        },
      };
    });
  };

  handleOtherChange = (index, field, value) => {
    this.setState((prevState) => {
      // 1. Create a shallow copy of the array
      const updatedOtherItems = [...prevState.managerSummary.otherItems];

      // 2. Create a BRAND NEW object for the item at this index
      // This is the "Magic" that makes the UI/Chips update instantly
      const updatedItem = {
        ...updatedOtherItems[index],
        [field]: field === 'isPermanent' ? !!value : value,
      };

      // 3. Handle specific parsing for the Amount field
      if (field === 'amount') {
        // Allow empty string while typing, otherwise parse it
        updatedItem.amount = value === '' ? '' : parseFloat(value) || 0;
      }

      // 4. Put the new item back into our array copy
      updatedOtherItems[index] = updatedItem;

      // 5. Recalculate totals
      const delivery = prevState.managerSummary.delivery || {};
      const deliveryTotal =
        (parseFloat(delivery.cash) || 0) +
        (parseFloat(delivery.managerZelle) || 0) +
        (parseFloat(delivery.atmReceipts) || 0) +
        (parseFloat(delivery.atmAdv) || 0);

      const otherTotal = updatedOtherItems.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );

      const totalDelivered = deliveryTotal + otherTotal;

      // 6. Return the new state
      return {
        managerSummary: {
          ...prevState.managerSummary,
          otherItems: updatedOtherItems,
          delivery: {
            ...prevState.managerSummary.delivery,
            totalDelivered,
          },
        },
      };
    });
  };

  handleWeeklyNetProfitBlur = (weeklyProfit) => {
    const { managerSummary } = this.state;
    if (weeklyProfit === null || weeklyProfit === '') return;

    weeklyProfit = parseFloat(weeklyProfit) || 0;

    const managerPct = parseFloat(managerSummary.manager.percentage) || 0;
    const profitThreshold =
      parseFloat(managerSummary.manager.profitThreshold) || 0;

    let managerShare = 0;
    if (weeklyProfit > profitThreshold) {
      const profitAboveThreshold = weeklyProfit - profitThreshold;
      managerShare = +(profitAboveThreshold * (managerPct / 100)).toFixed(2);
    }

    const remainingProfit = +(weeklyProfit - managerShare).toFixed(2);

    const additionsTotal = (managerSummary.adjustments.additions || []).reduce(
      (sum, item) => sum + (parseFloat(item.amount) || 0),
      0
    );
    const deductionsTotal = (
      managerSummary.adjustments.deductions || []
    ).reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);

    const adjustedTotal = +(
      remainingProfit +
      additionsTotal -
      deductionsTotal
    ).toFixed(2);

    this.setState({
      editedWeeklyNetProfit: null, // ← clear after blur
      managerSummary: {
        ...managerSummary,
        weeklyNetProfit: weeklyProfit,
        isWeeklyNetProfitEdited: true,
        manager: {
          ...managerSummary.manager,
          share: managerShare,
        },
        remainingProfit: remainingProfit,
        adjustments: {
          ...managerSummary.adjustments,
          adjustedTotal: adjustedTotal,
        },
      },
    });
  };

  handleDeliveryFocus = (field) => {
    this.setState((prevState) => ({
      deliveryInputValues: {
        ...prevState.deliveryInputValues,
        [field]:
          prevState.deliveryInputValues[field] === '0'
            ? ''
            : prevState.deliveryInputValues[field],
      },
    }));
  };

  handleDeliveryBlur = (field) => {
    this.setState((prevState) => {
      const raw = prevState.deliveryInputValues[field];
      if (raw === '' || raw === '-') {
        return {
          deliveryInputValues: {
            ...prevState.deliveryInputValues,
            [field]: '0',
          },
        };
      }
      return null;
    });
  };

  handleDeliveryChange = (field, value) => {
    // Update the raw string display value
    this.setState((prevState) => ({
      deliveryInputValues: {
        ...prevState.deliveryInputValues,
        [field]: value,
      },
    }));

    // Then update the numeric state (your existing logic)
    this.setState((prevState) => {
      let newValue = parseFloat(value);
      if (isNaN(newValue) || newValue < 0) newValue = 0;

      const updatedDelivery = {
        ...prevState.managerSummary.delivery,
        [field]: newValue,
      };

      const deliveryTotal =
        (updatedDelivery.cash || 0) +
        (updatedDelivery.managerZelle || 0) +
        (updatedDelivery.atmReceipts || 0) +
        (updatedDelivery.atmAdv || 0);

      const otherTotal = (prevState.managerSummary.otherItems || []).reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );

      // ── Sync delivery fields → matching ATM Cash Flow transactions ──────
      //   atmReceipts → ATM_FROM_PROFIT (ATM Added From Profit)
      //   atmAdv      → ATM_ADV
      // Keeps the two sections from drifting apart when the user edits
      // a value on the delivery side.
      let updatedATMTransactions =
        prevState.managerSummary.atmTransactions || [];
      const SYNC_MAP = {
        atmAdv: 'ATM_ADV',
        atmReceipts: 'ATM_FROM_PROFIT',
      };
      const syncedType = SYNC_MAP[field];
      if (syncedType) {
        const idx = updatedATMTransactions.findIndex(
          (t) => t.type === syncedType
        );
        if (idx > -1) {
          updatedATMTransactions = updatedATMTransactions.map((t, i) =>
            i === idx ? { ...t, amount: newValue } : t
          );
        } else {
          updatedATMTransactions = [
            ...updatedATMTransactions,
            { type: syncedType, amount: newValue, permanent: false },
          ];
        }
      }
      // ─────────────────────────────────────────────────────────────────────

      return {
        managerSummary: {
          ...prevState.managerSummary,
          delivery: {
            ...updatedDelivery,
            totalDelivered: deliveryTotal + otherTotal,
          },
          atmTransactions: updatedATMTransactions, // ← add this line
        },
      };
    });
  };

  handleATMFocus = (index, field, currentValue) => {
    this.setState({
      activeATMField: `${index}-${field}`,
      activeATMValue:
        currentValue === 0 || currentValue === '0' || currentValue == null
          ? ''
          : String(currentValue),
    });
  };

  handleATMBlur = () => {
    this.setState({ activeATMField: null, activeATMValue: '' });
  };

  handleATMChange = (index, field, value) => {
    this.setState((prevState) => {
      if (index === null) {
        // Update top-level Manager Name or Amount
        return {
          managerSummary: {
            ...prevState.managerSummary,
            [field]: value,
          },
        };
      }

      // Update ATM transaction row
      return {
        managerSummary: {
          ...prevState.managerSummary,
          atmTransactions: (prevState.managerSummary.atmTransactions || []).map(
            (atm, i) => {
              if (i !== index) return atm;

              let newValue = value;
              if (field === 'amount') {
                if (value === '') {
                  newValue = '';
                } else {
                  const reg = /^[0-9\b]+(\.[0-9]{0,2})?$/;
                  if (reg.test(value)) {
                    newValue = parseFloat(value);
                  }
                }
              }
              return { ...atm, [field]: newValue };
            }
          ),
        },
      };
    });
  };

  userHasATMRole = () => {
    const { userInfo } = this.props;
    const roles = userInfo?.authority || [];
    return roles.includes('ROLE_ATM_TRANSACTION');
  };

  isOwner = () => {
    const roles = this.props.userInfo?.authority || [];
    return roles.includes('ROLE_OWNER');
  };

  // Manager Name in ATM Cash Flow defaults to whatever the Manager
  // Setting holds, but ONLY when the summary doesn't already have one.
  // Once the Owner edits it manually and saves, the stored value wins
  // and we never overwrite it from settings again. Returns the same
  // object reference when no change is needed so equality checks stay
  // cheap.
  withManagerNameFallback = (ms) => {
    if (!ms) return ms;
    const current = String(ms.managerName || '').trim();
    if (current) return ms;
    const fromSetting = this.props.managerSetting?.managerName;
    if (!fromSetting) return ms;
    return { ...ms, managerName: fromSetting };
  };

  handleStaticATMChange = (type, value) => {
    const { atmTransactions } = this.state.managerSummary;
    const index = atmTransactions.findIndex((t) => t.type === type);

    if (index > -1) {
      // Update existing
      this.handleATMChange(index, 'amount', value);
    } else {
      // If for some reason the type isn't in the array yet, add it
      const newTransactions = [...atmTransactions, { type, amount: value }];
      this.setState({
        managerSummary: {
          ...this.state.managerSummary,
          atmTransactions: newTransactions,
        },
      });
    }
  };

  getATMTOTAL = () => {
    const { atmTransactions = [] } = this.state.managerSummary;
    return atmTransactions
      .filter(
        (atm) => atm.type === 'ATM_CASH' || atm.type === 'ATM_FROM_PROFIT'
      )
      .reduce((sum, atm) => sum + Number(atm.amount || 0), 0);
  };

  renderManagerTable = () => {
    const { managerSummary, editMode } = this.state;
    if (!managerSummary) return null;

    const { manager, remainingProfit, delivery, otherItems } = managerSummary;

    const disableButton = !this.canEditReport();

    return (
      <Grid
        container
        justifyContent="flex-start"
        sx={{
          p: { xs: 2, sm: 4 },
          width: '100%',
          height: 'calc(100vh - 300px)',
          overflowX: 'auto',
        }}
      >
        <Grid item xs={12}>
          {/* Toggle Edit/View Button */}
          <Button
            variant="outlined"
            style={{ marginBottom: '16px', marginTop: '-16px' }}
            startIcon={editMode ? <VisibilityIcon /> : <EditIcon />}
            onClick={() => this.setState({ editMode: !editMode })}
            sx={{ mb: 2 }}
            disabled={disableButton}
          >
            {editMode ? 'View Summary' : 'Edit Summary'}
          </Button>

          <Paper
            sx={{
              p: { xs: 2, sm: 4 },
              borderRadius: 2,
              width: '100%',
              maxWidth: '100%',
              textAlign: 'left',
              background: 'linear-gradient(145deg, #ffffff, #f9f9f9)',
              border: '1px solid #ddd',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.08)',
            }}
          >
            {/* Manager Info */}
            <Paper sx={{ mb: 3, bgcolor: '#e3f2fd', boxShadow: 'none' }}>
              <CardContent>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  Manager Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="body1">
                      <strong>Name:</strong> {manager.name}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="body1">
                      <strong>Manager:</strong> {manager.percentage}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="body1">
                      <strong>Share:</strong> ${this.fmtMoney2(manager.share)}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Paper>

            {/* Profit Summary */}
            <Paper sx={{ mb: 3, bgcolor: '#e8f5e9', boxShadow: 'none' }}>
              <CardContent>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  Profit Summary
                </Typography>
                <Grid container spacing={2} style={{ marginTop: '2px' }}>
                  <Grid item xs={12} sm={6}>
                    {editMode ? (
                      <TextField
                        label="Weekly Net Profit"
                        type="number"
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        value={
                          this.state.editedWeeklyNetProfit ??
                          managerSummary.weeklyNetProfit
                        }
                        onFocus={() =>
                          this.setState({
                            editedWeeklyNetProfit:
                              (this.state.editedWeeklyNetProfit ??
                                managerSummary.weeklyNetProfit) === 0
                                ? ''
                                : String(
                                    this.state.editedWeeklyNetProfit ??
                                      managerSummary.weeklyNetProfit
                                  ),
                          })
                        }
                        onChange={(e) =>
                          this.setState({
                            editedWeeklyNetProfit: parseFloat(e.target.value),
                          })
                        }
                        onBlur={() => {
                          const val = this.state.editedWeeklyNetProfit;
                          this.handleWeeklyNetProfitBlur(val);
                        }}
                        // onBlur={this.handleWeeklyNetProfitBlur}
                      />
                    ) : (
                      <Typography variant="body1">
                        <strong>Weekly Net Profit:</strong> $
                        {this.fmtMoney2(managerSummary.weeklyNetProfit)}
                      </Typography>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{ marginTop: editMode ? '16px' : '0px' }}
                  >
                    <Typography variant="body1">
                      <strong>Remaining Profit:</strong> $
                      {this.fmtMoney2(remainingProfit)}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Paper>

            {/* Adjustments */}
            {/* --- ADJUSTMENTS SECTION --- */}
            <Box sx={{ mb: 3 }}>
              <Grid container spacing={3}>
                {/* 1. ADDITIONS CARD (GREEN) */}
                <Grid item xs={12} md={6}>
                  <Paper
                    sx={{
                      p: 2,
                      bgcolor: '#e8f5e9',
                      borderRadius: 2,
                      height: '100%',
                      boxShadow: 'none',
                      border: '1px solid #c8e6c9',
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      color="#2e7d32"
                      gutterBottom
                    >
                      Additions (+)
                    </Typography>

                    {managerSummary.adjustments.additions.map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          mb: 2,
                          p: 2,
                          bgcolor: 'white',
                          borderRadius: 2,
                          border: '1px solid #a5d6a7',
                        }}
                      >
                        {editMode ? (
                          <Stack spacing={2}>
                            <Box sx={{ mb: 2 }}>
                              <Grid
                                container
                                alignItems="center"
                                wrap="nowrap" // Forces the Grid to stay on one line
                                spacing={1}
                              >
                                {/* Left Side: Label - Shrink to fit content */}
                                <Grid item>
                                  <Typography
                                    variant="caption"
                                    fontWeight={700}
                                    style={{
                                      color: '#666',
                                      textTransform: 'uppercase',
                                      whiteSpace: 'nowrap', // Prevents "Assign To" from breaking into two lines
                                      marginRight: '8px',
                                    }}
                                  >
                                    Assign To:
                                  </Typography>
                                </Grid>

                                {/* Right Side: Chips and Delete Button - Take up remaining space */}
                                <Grid item xs>
                                  <Box
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                      flexWrap: 'nowrap', // Forces chips to stay on one line
                                      overflowX: 'auto', // Allows scrolling if the names are very long on tiny screens
                                    }}
                                  >
                                    {['Liz', 'Eric'].map((name) => {
                                      const isSelected =
                                        item.assignedTo === name;
                                      return (
                                        <Chip
                                          key={name}
                                          label={name}
                                          onClick={() =>
                                            this.handleAdjustmentChange(
                                              'additions',
                                              index,
                                              'assignedTo',
                                              name
                                            )
                                          }
                                          style={{
                                            fontWeight: isSelected ? 700 : 500,
                                            cursor: 'pointer',
                                            backgroundColor: isSelected
                                              ? '#001251'
                                              : '#eaeaea',
                                            color: isSelected
                                              ? '#ffffff'
                                              : '#333333',
                                            minWidth: '55px',
                                            height: '28px', // Slightly shorter for a tighter one-row look
                                            marginRight: '6px',
                                          }}
                                        />
                                      );
                                    })}

                                    <IconButton
                                      color="error"
                                      size="small"
                                      onClick={() =>
                                        this.removeAdjustmentRow(
                                          'additions',
                                          index
                                        )
                                      }
                                      style={{ padding: '4px' }} // Smaller padding to save space
                                    >
                                      <RemoveCircleIcon fontSize="small" />
                                    </IconButton>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>

                            <TextField
                              fullWidth
                              label="Description"
                              size="small"
                              variant="outlined"
                              InputLabelProps={{ shrink: true }}
                              value={item.description}
                              onChange={(e) =>
                                this.handleAdjustmentChange(
                                  'additions',
                                  index,
                                  'description',
                                  e.target.value
                                )
                              }
                            />

                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <TextField
                                label="Amount"
                                type="number"
                                fullWidth
                                variant="outlined"
                                size="small"
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  ),
                                }}
                                value={item.amount}
                                onChange={(e) =>
                                  this.handleAdjustmentChange(
                                    'additions',
                                    index,
                                    'amount',
                                    e.target.value
                                  )
                                }
                              />
                            </Box>
                          </Stack>
                        ) : (
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Box>
                              <Typography fontWeight={500}>
                                {item.description}
                              </Typography>
                            </Box>
                            <Typography fontWeight={700} color="#2e7d32">
                              +${this.fmtMoney2(item.amount)}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ))}
                    {editMode && (
                      <Button
                        startIcon={<AddCircleIcon />}
                        onClick={() => this.addAdjustmentRow('additions')}
                        color="success"
                      >
                        Add Addition
                      </Button>
                    )}
                  </Paper>
                </Grid>

                {/* 2. DEDUCTIONS CARD (RED) */}
                <Grid item xs={12} md={6}>
                  <Paper
                    sx={{
                      p: 2,
                      bgcolor: '#ffebee',
                      borderRadius: 2,
                      height: '100%',
                      boxShadow: 'none',
                      border: '1px solid #ffcdd2',
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      color="#c62828"
                      gutterBottom
                    >
                      Deductions (–)
                    </Typography>

                    {managerSummary.adjustments.deductions.map(
                      (item, index) => (
                        <Box
                          key={index}
                          sx={{
                            mb: 2,
                            p: 2,
                            bgcolor: 'white',
                            borderRadius: 2,
                            border: '1px solid #ef9a9a',
                          }}
                        >
                          {editMode ? (
                            <Stack spacing={2}>
                              <Box sx={{ mb: 2 }}>
                                <Grid
                                  container
                                  alignItems="center"
                                  wrap="nowrap" // Forces the Grid to stay on one line
                                  spacing={1}
                                >
                                  {/* Left Side: Label - Shrink to fit content */}
                                  <Grid item>
                                    <Typography
                                      variant="caption"
                                      fontWeight={700}
                                      style={{
                                        color: '#666',
                                        textTransform: 'uppercase',
                                        whiteSpace: 'nowrap', // Prevents "Assign To" from breaking into two lines
                                        marginRight: '8px',
                                      }}
                                    >
                                      Assign To:
                                    </Typography>
                                  </Grid>

                                  {/* Right Side: Chips and Delete Button - Take up remaining space */}
                                  <Grid item xs>
                                    <Box
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end',
                                        flexWrap: 'nowrap', // Forces chips to stay on one line
                                        overflowX: 'auto', // Allows scrolling if the names are very long on tiny screens
                                      }}
                                    >
                                      {['Liz', 'Eric'].map((name) => {
                                        const isSelected =
                                          item.assignedTo === name;
                                        return (
                                          <Chip
                                            key={name}
                                            label={name}
                                            onClick={() =>
                                              this.handleAdjustmentChange(
                                                'deductions',
                                                index,
                                                'assignedTo',
                                                name
                                              )
                                            }
                                            style={{
                                              fontWeight: isSelected
                                                ? 700
                                                : 500,
                                              cursor: 'pointer',
                                              backgroundColor: isSelected
                                                ? '#001251'
                                                : '#eaeaea',
                                              color: isSelected
                                                ? '#ffffff'
                                                : '#333333',
                                              minWidth: '55px',
                                              height: '28px', // Slightly shorter for a tighter one-row look
                                              marginRight: '6px',
                                            }}
                                          />
                                        );
                                      })}

                                      <IconButton
                                        color="error"
                                        size="small"
                                        onClick={() =>
                                          this.removeAdjustmentRow(
                                            'deductions',
                                            index
                                          )
                                        }
                                        style={{ padding: '4px' }} // Smaller padding to save space
                                      >
                                        <RemoveCircleIcon fontSize="small" />
                                      </IconButton>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Box>

                              <TextField
                                fullWidth
                                label="Description"
                                size="small"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={item.description}
                                onChange={(e) =>
                                  this.handleAdjustmentChange(
                                    'deductions',
                                    index,
                                    'description',
                                    e.target.value
                                  )
                                }
                              />

                              <Box sx={{ display: 'flex', gap: 1 }}>
                                <TextField
                                  label="Amount"
                                  type="number"
                                  fullWidth
                                  variant="outlined"
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        $
                                      </InputAdornment>
                                    ),
                                  }}
                                  value={item.amount}
                                  onChange={(e) =>
                                    this.handleAdjustmentChange(
                                      'deductions',
                                      index,
                                      'amount',
                                      e.target.value
                                    )
                                  }
                                />
                              </Box>
                            </Stack>
                          ) : (
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <Box>
                                <Typography fontWeight={500}>
                                  {item.description}
                                </Typography>
                              </Box>
                              <Typography fontWeight={700} color="#c62828">
                                -${this.fmtMoney2(item.amount)}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      )
                    )}
                    {editMode && (
                      <Button
                        startIcon={<AddCircleIcon />}
                        onClick={() => this.addAdjustmentRow('deductions')}
                        color="error"
                      >
                        Add Deduction
                      </Button>
                    )}
                  </Paper>
                </Grid>
              </Grid>

              {/* Summary Bar */}
              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  bgcolor: 'rgb(235, 240, 255)',
                  color: 'black',
                  borderRadius: 2,
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Typography variant="h5" fontWeight={700}>
                  Adjusted Total: $
                  {this.fmtMoney2(managerSummary.adjustments.adjustedTotal)}
                </Typography>
              </Box>
            </Box>

            {/* Delivery & Other */}
            <Paper
              sx={{
                mb: 3,
                bgcolor: '#e1f5fe',
                boxShadow: 'none',
                p: 2,
                borderRadius: 2,
              }}
            >
              <Typography variant="h6" fontWeight={600} gutterBottom>
                How Was It Delivered?
              </Typography>

              <Grid container spacing={2} style={{ marginTop: '4px' }}>
                {[
                  { key: 'cash', label: 'Cash' },
                  { key: 'managerZelle', label: 'Zelle' },
                  { key: 'atmReceipts', label: 'ATM Receipts' },
                  { key: 'atmAdv', label: 'ATM ADV' },
                ].map(({ key, label }) => (
                  <Grid item xs={12} sm={6} key={key}>
                    {editMode ? (
                      <TextField
                        label={label}
                        type="number"
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={this.state.deliveryInputValues[key]}
                        onFocus={() => this.handleDeliveryFocus(key)} // ← clears "0" on focus
                        onBlur={() => this.handleDeliveryBlur(key)} // ← restores "0" if empt
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        defaultValue={delivery[key]}
                        onChange={(e) =>
                          this.handleDeliveryChange(key, e.target.value)
                        }
                        sx={{ mb: 1 }}
                      />
                    ) : (
                      <Typography>
                        <strong>{label}:</strong> $
                        {this.fmtMoney2(delivery[key])}
                      </Typography>
                    )}
                  </Grid>
                ))}
              </Grid>

              <Grid item xs={12}>
                <Paper
                  sx={{
                    p: 0,
                    bgcolor: '#e3f2fd', // Light Blue background
                    borderRadius: 2,
                    boxShadow: 'none',
                    mt: 2,
                  }}
                >
                  {otherItems.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 2,
                        p: 2,
                        bgcolor: 'white',
                        borderRadius: 2,
                        border: '1px solid #90caf9',
                      }}
                    >
                      {editMode ? (
                        <Stack spacing={2}>
                          <Box sx={{ mb: 2 }}>
                            <Grid
                              container
                              alignItems="center"
                              wrap="nowrap" // Forces the Grid to stay on one line
                              spacing={1}
                            >
                              {/* Left Side: Label - Shrink to fit content */}
                              <Grid item>
                                <Typography
                                  variant="caption"
                                  fontWeight={700}
                                  style={{
                                    color: '#666',
                                    textTransform: 'uppercase',
                                    whiteSpace: 'nowrap', // Prevents "Assign To" from breaking into two lines
                                    marginRight: '8px',
                                  }}
                                >
                                  Assign To:
                                </Typography>
                              </Grid>

                              {/* Right Side: Chips and Delete Button - Take up remaining space */}
                              <Grid item xs>
                                <Box
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    flexWrap: 'nowrap', // Forces chips to stay on one line
                                    overflowX: 'auto', // Allows scrolling if the names are very long on tiny screens
                                  }}
                                >
                                  {['Liz', 'Eric'].map((name) => {
                                    const isSelected = item.assignedTo === name;
                                    return (
                                      <Chip
                                        key={name}
                                        label={name}
                                        onClick={() =>
                                          this.handleOtherChange(
                                            index,
                                            'assignedTo',
                                            name
                                          )
                                        }
                                        style={{
                                          fontWeight: isSelected ? 700 : 500,
                                          cursor: 'pointer',
                                          backgroundColor: isSelected
                                            ? '#001251'
                                            : '#eaeaea',
                                          color: isSelected
                                            ? '#ffffff'
                                            : '#333333',
                                          minWidth: '55px',
                                          height: '28px', // Slightly shorter for a tighter one-row look
                                          marginRight: '6px',
                                        }}
                                      />
                                    );
                                  })}

                                  <IconButton
                                    color="error"
                                    size="small"
                                    onClick={() =>
                                      this.handleRemoveOther(index)
                                    }
                                    style={{ padding: '4px' }} // Smaller padding to save space
                                  >
                                    <RemoveCircleIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>

                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={item.isPermanent || false}
                                  onChange={(e) =>
                                    this.handleOtherChange(
                                      index,
                                      'isPermanent',
                                      e.target.checked
                                    )
                                  }
                                  color="primary"
                                />
                              }
                              label="Permanent"
                            />
                          </Box>

                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <TextField
                              fullWidth
                              label="Description"
                              size="small"
                              variant="outlined"
                              InputLabelProps={{ shrink: true }}
                              value={item.description}
                              onChange={(e) =>
                                this.handleOtherChange(
                                  index,
                                  'description',
                                  e.target.value
                                )
                              }
                            />
                          </Box>

                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <TextField
                              label="Amount"
                              type="number"
                              fullWidth
                              variant="outlined"
                              size="small"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                ),
                              }}
                              value={item.amount}
                              onChange={(e) =>
                                this.handleOtherChange(
                                  index,
                                  'amount',
                                  e.target.value
                                )
                              }
                            />
                          </Box>
                        </Stack>
                      ) : (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <Box>
                            <Typography fontWeight={500}>
                              {item.description}
                            </Typography>
                          </Box>
                          <Typography fontWeight={700} color="#1565c0">
                            ${this.fmtMoney2(item.amount)}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  ))}

                  {editMode && (
                    <Button
                      startIcon={<AddCircleIcon />}
                      onClick={this.handleAddOther}
                      sx={{ justifyContent: 'flex-start', color: '#1565c0' }}
                    >
                      Add Other
                    </Button>
                  )}
                </Paper>
              </Grid>

              <Typography
                variant="h5"
                fontWeight={700}
                align="right"
                sx={{ mt: 2 }}
              >
                Total Delivered: ${this.fmtMoney2(delivery.totalDelivered)}
              </Typography>

              {/* $5 rule: Adjusted Total vs Total Delivered. A real-time
                  warning so the user sees the discrepancy while they're
                  still editing — the Save handler enforces the same
                  rule and blocks the request if it isn't resolved. */}
              {(() => {
                const { delta } = this.getDeliveryDelta();
                const tol = ReportView.DELIVERY_VS_ADJUSTED_TOLERANCE;
                if (Math.abs(delta) <= tol) return null;
                const comparison = delta > 0 ? 'less than' : 'more than';
                return (
                  <Alert
                    severity="warning"
                    variant="filled"
                    sx={{ mt: 2, fontWeight: 600 }}
                  >
                    Total Delivered is ${this.fmtMoney2(Math.abs(delta))}{' '}
                    {comparison} Adjusted Total. The two must match within
                    ${this.fmtMoney2(tol)} before saving.
                  </Alert>
                );
              })()}
            </Paper>

            {/*ATM Transactions*/}
            {this.userHasATMRole() && (
              <Paper
                sx={{
                  mb: 3,
                  bgcolor: '#fbd9d3',
                  boxShadow: 'none',
                  p: 3,
                  borderRadius: 2,
                }}
              >
                <Typography variant="h6" fontWeight={600} sx={{ mb: 3 }}>
                  ATM Cash Flow
                </Typography>

                {/* Header: Manager & Overall Total */}
                {/* Manager Name + Amount at the top */}
                <Box
                  sx={{
                    display: 'flex',
                    gap: 2,
                    mb: 2,
                    flexDirection: editMode ? 'column' : 'row',
                    alignItems: 'center',
                  }}
                >
                  {editMode ? (
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          label="Manager Name"
                          name="managerName"
                          type="text"
                          value={managerSummary.managerName || ''}
                          onChange={(e) =>
                            this.handleATMChange(
                              null,
                              'managerName',
                              e.target.value
                            )
                          }
                          disabled={!this.isOwner()}
                          InputProps={{ readOnly: !this.isOwner() }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          label="Weekly Starting Cash"
                          name="totalATMCash"
                          type="number"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                $
                              </InputAdornment>
                            ),
                          }}
                          value={
                            this.state.activeATMField === 'null-totalATMCash'
                              ? this.state.activeATMValue
                              : String(managerSummary.totalATMCash ?? 0)
                          }
                          onFocus={() =>
                            this.handleATMFocus(
                              null,
                              'totalATMCash',
                              managerSummary.totalATMCash
                            )
                          }
                          onBlur={this.handleATMBlur}
                          onChange={(e) => {
                            this.setState({ activeATMValue: e.target.value });
                            this.handleATMChange(
                              null,
                              'totalATMCash',
                              e.target.value
                            );
                          }}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <>
                      <Box
                        sx={{
                          p: 2,
                          width: '100%',
                          borderRadius: 2,
                          bgcolor: '#FFB09C',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="caption"
                          fontWeight={700}
                          sx={{ textTransform: 'uppercase' }}
                        >
                          {managerSummary.managerName || '—'}
                        </Typography>

                        <Typography variant="h6" fontWeight={600}>
                          ${this.fmtMoney2(managerSummary.totalATMCash)}
                        </Typography>
                      </Box>
                    </>
                  )}
                </Box>

                <Grid container spacing={2}>
                  {[
                    'ATM_CASH',
                    'ATM_FROM_PROFIT',
                    'ATM_ADV',
                    'ATM_DIDNT_USE',
                  ].map((typeCode) => {
                    // Find the existing data for this type or default to 0
                    const txn = managerSummary.atmTransactions?.find(
                      (t) => t.type === typeCode
                    ) || { type: typeCode, amount: 0 };
                    // Find the label from your constant
                    const label =
                      ATM_TYPES.find((t) => t.value === typeCode)?.label ||
                      typeCode;

                    return (
                      <Grid item xs={12} sm={6} key={typeCode}>
                        <Box
                          sx={{
                            p: editMode ? 0 : 2,
                            borderRadius: 2,
                            display: 'flex',
                            bgcolor: !editMode ? '#FFB09C' : 'none',
                            flexDirection: 'column',
                            gap: 1,
                          }}
                        >
                          {editMode ? (
                            <TextField
                              fullWidth
                              variant="outlined"
                              label={
                                label === 'ATM Cash'
                                  ? 'ATM Cash Used'
                                  : label === 'ATM From Profit'
                                  ? 'ATM Added From Profit'
                                  : label
                              }
                              name={typeCode}
                              type="number"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                ),
                              }}
                              value={
                                this.state.activeATMField ===
                                `static-${typeCode}`
                                  ? this.state.activeATMValue
                                  : String(txn.amount ?? 0)
                              }
                              onFocus={() =>
                                this.handleATMFocus(
                                  `static`,
                                  typeCode,
                                  txn.amount
                                )
                              }
                              onBlur={this.handleATMBlur}
                              onChange={(e) => {
                                this.setState({
                                  activeATMValue: e.target.value,
                                });
                                this.handleStaticATMChange(
                                  typeCode,
                                  e.target.value
                                );
                              }}
                            />
                          ) : (
                            <>
                              <Typography
                                variant="caption"
                                fontWeight={700}
                                sx={{ textTransform: 'uppercase' }}
                              >
                                {label === 'ATM Cash'
                                  ? 'ATM Cash Used'
                                  : label === 'ATM From Profit'
                                  ? 'ATM Added From Profit'
                                  : label}
                              </Typography>
                              <Typography variant="h6" fontWeight={600}>
                                ${this.fmtMoney2(txn.amount)}
                              </Typography>
                            </>
                          )}
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>

                <Typography
                  variant="h5"
                  fontWeight={700}
                  align="right"
                  sx={{ mt: 2 }}
                >
                  ATM Cash Total: ${this.fmtMoney2(this.getATMTOTAL())}
                </Typography>
              </Paper>
            )}

            {/* Save Button */}
            {editMode && (
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                justifyContent="flex-start"
                sx={{ mt: 3 }}
              >
                <Button
                  size="large"
                  onClick={() => {
                    this.handleSaveManagerSummary();
                  }}
                  variant="contained"
                  color="primary"
                >
                  Save
                </Button>
              </Stack>
            )}
          </Paper>
        </Grid>
      </Grid>
    );
  };

  // ──────────────────────────────────────────────────────────────
  // Short Analysis (Equation X)
  // ──────────────────────────────────────────────────────────────
  fmtMoney = (n) => {
    const v = Number(n) || 0;
    const str = '$' + Math.abs(v).toLocaleString('en-US');
    if (v < 0) return `-${str}`;
    if (v > 0) return `+${str}`;
    return str;
  };

  fmtPlain = (n) => '$' + Math.abs(Number(n) || 0).toLocaleString('en-US');

  // Display-only currency formatter for the Manager Summary section.
  // Always renders 2 decimal places with thousands separators
  // (e.g. 1234 → "1,234.00"). Use this instead of `.toLocaleString()`
  // for any money value shown in that section — plain `.toLocaleString()`
  // drops trailing zeros so "$540" reads differently from "$540.00".
  fmtMoney2 = (n) =>
    (Number(n) || 0).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  // Adjusted Total vs Total Delivered must agree within this tolerance
  // (in dollars). Anything beyond is treated as a real discrepancy:
  // an inline warning surfaces it in the UI and Save is blocked.
  static DELIVERY_VS_ADJUSTED_TOLERANCE = 5;

  getDeliveryDelta = () => {
    const ms = this.state.managerSummary || {};
    const adjusted = Number(ms?.adjustments?.adjustedTotal) || 0;
    const delivered = Number(ms?.delivery?.totalDelivered) || 0;
    return { adjusted, delivered, delta: adjusted - delivered };
  };

  sxBadge = (value, size = 'sm') => {
    const v = Number(value) || 0;
    const neg = v < 0;
    const pos = v > 0;
    const bg = neg ? '#FEE2E2' : pos ? '#D1FAE5' : '#F3F4F6';
    const color = neg ? '#DC2626' : pos ? '#059669' : '#6B7280';
    const fs = size === 'lg' ? 22 : size === 'md' ? 15 : 13;
    const pad =
      size === 'lg' ? '8px 16px' : size === 'md' ? '4px 10px' : '3px 8px';
    return (
      <span
        style={{
          background: bg,
          color,
          fontSize: fs,
          fontWeight: 700,
          padding: pad,
          borderRadius: 8,
          display: 'inline-block',
          fontFamily: "'JetBrains Mono', monospace",
        }}
      >
        {this.fmtMoney(v)}
      </span>
    );
  };

  sxCard = ({ title, icon, accent, children, alert }) => (
    <div
      style={{
        background: alert ? '#FFF5F5' : '#FFF',
        borderRadius: 16,
        padding: '18px 16px',
        marginBottom: 12,
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        borderLeft: `4px solid ${accent || '#E5E7EB'}`,
        border: alert ? '1px solid #FECACA' : undefined,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginBottom: 12,
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: 1.1,
          color: alert ? '#DC2626' : '#9CA3AF',
        }}
      >
        <span style={{ fontSize: 15 }}>{icon}</span>
        {title}
      </div>
      {children}
    </div>
  );

  sxRow = ({ label, value, sub, bold, border }) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '9px 0',
        borderBottom: border ? '1px solid #F3F4F6' : 'none',
      }}
    >
      <div>
        <div
          style={{
            fontSize: 13,
            color: '#374151',
            fontWeight: bold ? 700 : 400,
          }}
        >
          {label}
        </div>
        {sub && (
          <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 1 }}>
            {sub}
          </div>
        )}
      </div>
      <div
        style={{
          fontSize: 13,
          fontWeight: bold ? 700 : 500,
          fontFamily: "'JetBrains Mono', monospace",
        }}
      >
        {value}
      </div>
    </div>
  );

  sxEmployeeRow = (emp, isWorst) => (
    <div
      key={(emp.userId || emp.name) + '-' + (emp.clockId || '')}
      style={{
        background: isWorst ? '#FFF5F5' : '#FAFAFA',
        border: isWorst ? '1px solid #FECACA' : '1px solid #F3F4F6',
        borderRadius: 12,
        padding: '12px 14px',
        marginBottom: 8,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div
            style={{
              width: 34,
              height: 34,
              borderRadius: 10,
              background: isWorst ? '#FEE2E2' : '#EEF2FF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 13,
              fontWeight: 700,
              color: isWorst ? '#DC2626' : '#4F46E5',
            }}
          >
            {(emp.name || '?').charAt(0).toUpperCase()}
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>
              {emp.name}
            </div>
            <div style={{ fontSize: 11, color: '#9CA3AF' }}>
              {emp.didPulls ? `Pulls: ${this.fmtPlain(emp.pulls)}` : 'No pulls'}{' '}
              · Tickets: {this.fmtPlain(emp.ticketOut)}
            </div>
          </div>
        </div>
        {this.sxBadge(emp.shiftShort)}
      </div>
      {emp.note && (
        <div
          style={{
            marginTop: 8,
            fontSize: 11,
            color: '#D97706',
            background: '#FFFBEB',
            borderRadius: 8,
            padding: '6px 10px',
            border: '1px solid #FDE68A',
          }}
        >
          <span role="img" aria-label="warning">
            ⚠️
          </span>{' '}
          {emp.note}
        </div>
      )}
    </div>
  );

  sxNoteCard = (note, i) => {
    const colors = {
      alert: { bg: '#FEF2F2', border: '#FECACA', title: '#991B1B' },
      action: { bg: '#EFF6FF', border: '#BFDBFE', title: '#1E40AF' },
      warning: { bg: '#FFFBEB', border: '#FDE68A', title: '#92400E' },
      info: { bg: '#F0FDF4', border: '#BBF7D0', title: '#166534' },
      critical: { bg: '#FEF2F2', border: '#FCA5A5', title: '#7F1D1D' },
    };
    const icons = {
      alert: '🔴',
      action: '🔧',
      warning: '⚠️',
      info: '💡',
      critical: '🚨',
    };
    const c = colors[note.type] || colors.info;
    return (
      <div
        key={i}
        style={{
          background: c.bg,
          border: `1px solid ${c.border}`,
          borderRadius: 12,
          padding: '14px',
          marginBottom: 8,
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 6,
          }}
        >
          <span style={{ fontSize: 14 }}>{icons[note.type] || '📝'}</span>
          <span style={{ fontSize: 13, fontWeight: 700, color: c.title }}>
            {note.title}
          </span>
        </div>
        <div
          style={{
            fontSize: 12,
            color: '#475569',
            lineHeight: 1.5,
            whiteSpace: 'pre-line',
          }}
        >
          {note.body}
        </div>
      </div>
    );
  };

  buildShortAnalysisNotes = (dayData) => {
    const notes = [];
    const pullsGap = Number(dayData.pullsGap) || 0;
    const matchDiff = Number(dayData.matchTicketsDiff) || 0;
    const matchDiffRaw = Number(dayData.matchTicketsDiffRaw) || 0;
    const jackpotNotPay = Number(dayData.jackpotNotPay) || 0;
    const weeklyShort = Number(dayData.weeklyShortOver) || 0;
    const overTicketMachines = dayData.overTicketMachines || [];
    const missingExpenses = dayData.missingDailyExpenses || [];
    const duplicateExpenses = dayData.duplicateDailyExpenses || [];
    const fp = this.fmtPlain;
    const fm = this.fmtMoney;
    const absShort = Math.abs(weeklyShort);
    const absPulls = Math.abs(pullsGap);

    // 1. Over-tickets analysis — per machine, source tracing via matching
    // tickets. Only surface over-ticket amounts greater than $10; trivial
    // amounts ($1–$2) are almost always counting dust and flood the
    // recommendation panel without being actionable.
    const OVER_TICKET_THRESHOLD = 10;
    overTicketMachines
      .filter(
        (m) => Math.abs(Number(m.overAmount) || 0) > OVER_TICKET_THRESHOLD
      )
      .forEach((m) => {
        const matches = m.matches || [];
        const lines = matches
          .map((x) => `- ${x.employee} entered ${fp(x.amount)}`)
          .join('\n');
        // Use unique employee names, not unique (employee, amount)
        // pairs. That way a single employee who entered two separate
        // candidate tickets on the same machine is still reported as
        // the sole source, and "either employee" only appears when
        // two or more distinct people entered tickets on it.
        const uniqueEmployees = [
          ...new Set(matches.map((x) => x.employee).filter(Boolean)),
        ];
        let source = '';
        if (uniqueEmployees.length === 1) {
          source = `\nMost likely source: ${uniqueEmployees[0]}`;
        } else if (uniqueEmployees.length > 1) {
          source = `\nPossible source: ${uniqueEmployees.join(' or ')}`;
        }
        notes.push({
          type: 'warning',
          title: `Machine #${m.machine} has ${fp(m.overAmount)} over tickets`,
          body:
            (matches.length
              ? `Matching tickets found:\n${lines}`
              : 'No matching ticket entries found for this machine.') + source,
        });
      });

    // 2. Money In (Room Over) — strict causes only
    if (weeklyShort > 0) {
      notes.push({
        type: 'info',
        title: `Room over: ${fp(weeklyShort)}`,
        body:
          `Room shows more money than the actual reading.\n` +
          `Most likely cause: miscount or incorrect PULLS entry.\n` +
          `Wait until end of day and verify final balance.`,
      });
    }

    // 3. Money Shortage Analysis — tiered by magnitude
    if (weeklyShort < 0) {
      if (absShort < 40) {
        notes.push({
          type: 'info',
          title: `Small shortage: ${fm(weeklyShort)}`,
          body: `Likely cause: miscount.`,
        });
      } else if (absShort <= 300) {
        notes.push({
          type: 'warning',
          title: `Shortage: ${fm(weeklyShort)}`,
          body:
            `Possible causes:\n` +
            `- Employee counting error\n` +
            `- Machine was not opened (most likely the last active machine)\n` +
            `Wait until next session and check if the money appears in the next reading.`,
        });
      } else {
        notes.push({
          type: 'alert',
          title: `Significant shortage: ${fm(weeklyShort)}`,
          body:
            `Possible causes:\n` +
            `- Cash still inside machines\n` +
            `- Reading error\n` +
            `- Employee-related issue\n` +
            `Step 1: Open all machines immediately and verify internal cash.\n` +
            `Step 2: If not found, wait until next session to check for reading correction.\n` +
            `Step 3: If still missing, escalate as internal issue.`,
        });
      }
    }

    // 4. Pulls Gap — only surface when the gap is negative (employees
    // pulled less than the machines read, i.e. money is missing). A
    // positive gap means employees pulled more than the reading shows,
    // which is expected counting noise and doesn't need an analysis row.
    if (pullsGap < 0 && absPulls > 300) {
      notes.push({
        type: 'alert',
        title: `Pulls gap: ${fm(pullsGap)}`,
        body:
          `Open all machines immediately and verify if the missing money is still inside.\n` +
          `- If found: issue resolved, no escalation required.\n` +
          `- If not found: wait until next session and check if the discrepancy corrects in the next reading.\n` +
          `- If still missing: escalate as internal issue.`,
      });
    } else if (pullsGap < 0 && absPulls > 0) {
      notes.push({
        type: 'info',
        title: `Pulls gap: ${fm(pullsGap)}`,
        body: `Likely a minor counting difference. Review final balance and monitor next session.`,
      });
    }

    // 5. Unrecorded ticket-outs (cushion).
    // matchDiff is the REAL diff (raw − jackpotNotPay), so if jackpots fully
    // explain the raw gap, no warning fires. When a jackpot partially explains
    // it, note that the residual is what's unaccounted for.
    if (matchDiff > 0) {
      const jackpotNote =
        jackpotNotPay > 0
          ? `\n${fp(
              jackpotNotPay
            )} of the raw gap is explained by a jackpot that was not paid; the remaining ${fp(
              matchDiff
            )} is unaccounted for.`
          : '';
      notes.push({
        type: 'warning',
        title: `${fp(matchDiff)} in ticket-outs not recorded`,
        body:
          `Some ticket-outs were paid but not entered into the system. Unable to determine which employee recorded them.` +
          jackpotNote,
      });
    } else if (matchDiffRaw > 0 && jackpotNotPay > 0) {
      notes.push({
        type: 'info',
        title: `Ticket-out gap fully explained by jackpot not paid`,
        body: `Raw reading-out vs. ticket-out gap of ${fp(
          matchDiffRaw
        )} is covered by ${fp(
          jackpotNotPay
        )} in jackpots not paid. No missing ticket entries.`,
      });
    }

    // 6. Missing fixed daily expenses (only when one or more are missing)
    if (missingExpenses.length > 0) {
      const lines = missingExpenses.map((x) => `- ${x}`).join('\n');
      notes.push({
        type: 'warning',
        title: 'Missing daily expense',
        body: `${lines}\nVerify if this payment was made but not recorded.`,
      });
    }

    // 6b. Duplicate fixed daily expenses — same payroll or food entry
    // recorded more than once in the same shift.
    if (duplicateExpenses.length > 0) {
      const lines = duplicateExpenses.map((x) => `- ${x}`).join('\n');
      notes.push({
        type: 'warning',
        title: 'Duplicate daily expense',
        body: `${lines}\nThis expense was recorded more than once. Verify it wasn't paid twice.`,
      });
    }

    // 7. Recommended actions — only when the room is actually short
    // (negative). If the room is over or exactly matched, the prompt
    // to hunt for missing expenses doesn't apply.
    if (weeklyShort < 0) {
      const actions = [];
      if (absShort > 300 || (pullsGap < 0 && absPulls > 300)) {
        actions.push('- Open all machines immediately (shortage above $300).');
      }
      if (missingExpenses.length > 0) {
        actions.push(
          '- Verify missing daily expense(s) — check if paid but not recorded.'
        );
      }
      if (duplicateExpenses.length > 0) {
        actions.push(
          '- Review duplicate daily expense(s) — confirm the payment was not double-counted.'
        );
      }
      actions.push('- Ask employees if any expense was paid but not recorded.');

      notes.push({
        type: 'action',
        title: 'Recommended actions',
        body: actions.join('\n'),
      });
    }

    return notes;
  };

  renderShortAnalysis = () => {
    const { shortAnalysis } = this.props;
    const { selectedDay } = this.state;
    const Card = this.sxCard;
    const Row = this.sxRow;

    if (!shortAnalysis || !shortAnalysis.days) {
      return (
        <div style={{ padding: 24, color: '#6B7280', textAlign: 'center' }}>
          Loading Short Analysis…
        </div>
      );
    }

    const dayData = (shortAnalysis.days || []).find(
      (d) => d.day === selectedDay
    );
    if (!dayData) {
      return (
        <div
          style={{
            background: '#FFF',
            borderRadius: 18,
            padding: '40px 20px',
            textAlign: 'center',
            margin: '12px 0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
          }}
        >
          <div style={{ fontSize: 40, marginBottom: 12 }}>
            <span role="img" aria-label="no data">
              📭
            </span>
          </div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 700,
              color: '#374151',
              marginBottom: 6,
            }}
          >
            No Session Data
          </div>
          <div style={{ fontSize: 13, color: '#9CA3AF' }}>
            No reading session was recorded for {selectedDay}.
          </div>
        </div>
      );
    }

    // matchTicketsDiff from backend is the "real" diff (raw − jackpotNotPay);
    // matchTicketsDiffRaw is the unadjusted reading-out vs. ticket-out diff.
    const matchDiff = Number(dayData.matchTicketsDiff) || 0;
    const matchDiffRaw = Number(dayData.matchTicketsDiffRaw) || 0;
    const jackpotNotPay = Number(dayData.jackpotNotPay) || 0;
    const pullsGap = Number(dayData.pullsGap) || 0;
    const empShorts = Number(dayData.employeeShortsTotal) || 0;
    const weeklyShort = Number(dayData.weeklyShortOver) || 0;
    const equationX = Number(dayData.equationX) || 0;
    const matches = !!dayData.match;

    const sortedEmps = [...(dayData.employees || [])].sort(
      (a, b) => (a.shiftShort ?? 0) - (b.shiftShort ?? 0)
    );

    const totalEmployeePulls = (dayData.employees || []).reduce(
      (s, e) => s + (Number(e.pulls) || 0),
      0
    );
    // Ticket Out Total reconstructs actual recorded ticket-outs from the
    // raw reading diff (readingOut − rawDiff = ticketOutValue).
    const ticketOutTotal =
      (Number(dayData.readingTotalOut) || 0) - matchDiffRaw;

    const notes = this.buildShortAnalysisNotes(dayData);

    return (
      <div
        style={{
          fontFamily:
            "'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
        }}
      >
        {/* Summary Header */}
        <div
          style={{
            background: 'linear-gradient(135deg, #1E293B 0%, #334155 100%)',
            borderRadius: 18,
            padding: '20px 18px',
            marginBottom: 12,
            color: '#FFF',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  color: '#94A3B8',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                }}
              >
                Short / Over
              </div>
              <div
                style={{
                  fontSize: 34,
                  fontWeight: 800,
                  marginTop: 4,
                  fontFamily: "'JetBrains Mono', monospace",
                  color:
                    weeklyShort < 0
                      ? '#FCA5A5'
                      : weeklyShort > 0
                      ? '#6EE7B7'
                      : '#CBD5E1',
                }}
              >
                {this.fmtMoney(weeklyShort)}
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#E0E7FF' }}>
                {dayData.day}
              </div>
              <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 2 }}>
                {dayData.dateFormatted || '—'}
              </div>
            </div>
          </div>
        </div>

        {/* Pulls Comparison */}
        <Card title="Pulls Comparison" icon="📥" accent="#6366F1">
          <Row
            label="Reading Total IN"
            value={this.fmtPlain(dayData.readingTotalIn)}
            border
          />
          <Row
            label="Employee Total Pulls"
            value={this.fmtPlain(totalEmployeePulls)}
            border
          />
          <Row
            label="Pulls Gap"
            value={this.sxBadge(pullsGap, 'md')}
            sub="General — not attributable to specific employee"
            bold
          />
        </Card>

        {/* Match Tickets */}
        <Card
          title="Match Tickets"
          icon="🎫"
          accent={matchDiff < 0 ? '#DC2626' : '#10B981'}
        >
          <Row
            label="Reading Out Total"
            value={this.fmtPlain(dayData.readingTotalOut)}
            border
          />
          <Row
            label="Ticket Out Total"
            value={this.fmtPlain(ticketOutTotal)}
            border
          />
          {jackpotNotPay !== 0 ? (
            <>
              <Row
                label="Difference"
                value={this.sxBadge(matchDiffRaw, 'md')}
                border
              />
              <Row
                label="Jackpot Not Pay"
                value={this.fmtPlain(jackpotNotPay)}
                border
              />
              <Row
                label="Real Difference"
                value={this.sxBadge(matchDiff, 'md')}
                sub={
                  matchDiff > 0
                    ? 'Unrecorded ticket-outs (cushion, after jackpot not paid)'
                    : matchDiff < 0
                    ? 'Over-tickets — employees paid out MORE'
                    : 'Perfect match after jackpot not paid'
                }
                bold
              />
            </>
          ) : (
            <Row
              label="Difference"
              value={this.sxBadge(matchDiff, 'md')}
              sub={
                matchDiff > 0
                  ? 'Unrecorded ticket-outs (cushion)'
                  : matchDiff < 0
                  ? 'Over-tickets — employees paid out MORE'
                  : 'Perfect match'
              }
              bold
            />
          )}
        </Card>

        {/* Employee Shorts */}
        <Card title="Employee Shorts" icon="👥" accent="#F59E0B">
          {sortedEmps.length === 0 ? (
            <div style={{ fontSize: 13, color: '#6B7280' }}>
              No employee shift data for this session.
            </div>
          ) : (
            <>
              {sortedEmps.map((emp) => this.sxEmployeeRow(emp, false))}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px 14px',
                  background: '#F9FAFB',
                  borderRadius: 10,
                  border: '1px solid #E5E7EB',
                  marginTop: 4,
                }}
              >
                <span
                  style={{ fontSize: 13, fontWeight: 700, color: '#374151' }}
                >
                  Total Employee Shorts
                </span>
                {this.sxBadge(empShorts, 'md')}
              </div>
            </>
          )}
        </Card>

        {/* Equation X Proof */}
        <Card
          title="Equation X — Proof"
          icon="🧮"
          accent={matches ? '#8B5CF6' : '#DC2626'}
          alert={!matches}
        >
          <div
            style={{
              background: matches ? '#F8FAFC' : '#FEF2F2',
              borderRadius: 12,
              padding: '16px',
              border: matches ? '2px dashed #CBD5E1' : '2px dashed #FCA5A5',
              fontFamily: "'JetBrains Mono', monospace",
            }}
          >
            {[
              { label: 'Pulls Gap', val: pullsGap },
              { label: 'Match Tickets', val: matchDiff },
              { label: 'Employee Shorts', val: empShorts },
            ].map((item, i) => (
              <div
                key={item.label}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '6px 0',
                  fontSize: 14,
                  color: '#334155',
                  borderBottom:
                    i < 2
                      ? `1px solid ${matches ? '#E2E8F0' : '#FECACA'}`
                      : 'none',
                }}
              >
                <span>{item.label}</span>
                <span
                  style={{
                    color: item.val < 0 ? '#DC2626' : '#059669',
                    fontWeight: 600,
                  }}
                >
                  {this.fmtMoney(item.val)}
                </span>
              </div>
            ))}
            <div
              style={{
                borderTop: `2px solid ${matches ? '#64748B' : '#EF4444'}`,
                paddingTop: 10,
                marginTop: 8,
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: 16,
                fontWeight: 800,
              }}
            >
              <span>Equation X</span>
              <span style={{ color: equationX < 0 ? '#DC2626' : '#059669' }}>
                {this.fmtMoney(equationX)}
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: 16,
                fontWeight: 800,
                paddingTop: 6,
              }}
            >
              <span>Weekly Report</span>
              <span style={{ color: weeklyShort < 0 ? '#DC2626' : '#059669' }}>
                {this.fmtMoney(weeklyShort)}
              </span>
            </div>
            {matches ? (
              <div
                style={{
                  textAlign: 'center',
                  marginTop: 10,
                  fontSize: 13,
                  color: '#059669',
                  fontWeight: 700,
                  background: '#D1FAE5',
                  borderRadius: 8,
                  padding: '8px 0',
                }}
              >
                ✓ Balance Matched - Difference Identified
              </div>
            ) : (
              <div
                style={{
                  textAlign: 'center',
                  marginTop: 10,
                  fontSize: 13,
                  color: '#991B1B',
                  fontWeight: 700,
                  background: '#FEE2E2',
                  borderRadius: 8,
                  padding: '8px 0',
                }}
              >
                ✗ MISMATCH — check data entry
              </div>
            )}
          </div>
        </Card>

        {/* Analysis & Recommendations */}
        <Card title="Analysis & Recommendations" icon="📋" accent="#0EA5E9">
          {notes.map((note, i) => this.sxNoteCard(note, i))}
        </Card>

        {/* Equation X is included in the Full Report PDF via the toolbar download button */}
      </div>
    );
  };

  downloadShortAnalysisPdf = (dayData) => {
    const { userInfo } = this.props;
    const locName = userInfo?.selectedLocationName || 'NUVE SYSTEM';
    console.log(this.props);
    const C = PDF_COLORS;
    const doc = new jsPDF({ unit: 'pt', format: 'letter' });
    const pageW = doc.internal.pageSize.getWidth();
    const margin = 40;
    const f = this.fmtMoney;

    // Header (indigo, matches UI gradient start #312E81)
    doc.setFillColor(49, 46, 129);
    doc.rect(0, 0, pageW, 48, 'F');
    doc
      .setFont('helvetica', 'bold')
      .setFontSize(14)
      .setTextColor(...C.WHITE);
    doc.text(locName, margin, 22);
    doc
      .setFont('helvetica', 'normal')
      .setFontSize(10)
      .setTextColor(199, 210, 254);
    doc.text(`Short Analysis (Equation X) — ${dayData.day}`, margin, 38);
    doc.setFontSize(9).setTextColor(...C.WHITE);
    doc.text(dayData.dateFormatted || '', pageW - margin, 22, {
      align: 'right',
    });

    let y = 100;
    const isShort = (dayData.weeklyShortOver ?? 0) < 0;

    // Short/Over big number
    doc
      .setFont('helvetica', 'bold')
      .setFontSize(11)
      .setTextColor(...C.GRAY_TEXT);
    doc.text('Weekly Report Short/Over', margin, y);
    y += 32;
    doc
      .setFontSize(28)
      .setTextColor(isShort ? 220 : 22, isShort ? 38 : 163, isShort ? 38 : 74);
    doc.text(f(dayData.weeklyShortOver), margin, y);
    y += 28;

    const pdfTotalPulls = (dayData.employees || []).reduce(
      (s, e) => s + (Number(e.pulls) || 0),
      0
    );
    const pdfMatchDiff = Number(dayData.matchTicketsDiff) || 0;
    const pdfMatchDiffRaw = Number(dayData.matchTicketsDiffRaw) || 0;
    const pdfJackpotNotPay = Number(dayData.jackpotNotPay) || 0;
    const pdfTicketOutTotal =
      (Number(dayData.readingTotalOut) || 0) - pdfMatchDiffRaw;

    // Pulls Comparison
    autoTable(doc, {
      startY: y,
      head: [['Pulls Comparison', '']],
      body: [
        ['Reading Total IN', f(dayData.readingTotalIn)],
        ['Employee Total Pulls', f(pdfTotalPulls)],
        ['Pulls Gap', f(dayData.pullsGap)],
      ],
      theme: 'grid',
      styles: { fontSize: 10 },
      headStyles: { fillColor: [79, 70, 229], textColor: 255 },
      margin: { left: margin, right: margin },
    });
    y = doc.lastAutoTable.finalY + 16;

    // Match Tickets
    const pdfMatchBody = [
      ['Reading Out Total', f(dayData.readingTotalOut)],
      ['Ticket Out Total', f(pdfTicketOutTotal)],
      [
        'Difference',
        f(pdfJackpotNotPay !== 0 ? pdfMatchDiffRaw : pdfMatchDiff),
      ],
    ];
    if (pdfJackpotNotPay !== 0) {
      pdfMatchBody.push(['Jackpot Not Pay', f(pdfJackpotNotPay)]);
      pdfMatchBody.push(['Real Difference', f(pdfMatchDiff)]);
    }
    pdfMatchBody.push([
      'Meaning',
      pdfMatchDiff < 0
        ? 'Over-tickets — direct loss'
        : pdfMatchDiff > 0
        ? 'Unrecorded ticket-outs — cushion'
        : 'Perfect match',
    ]);
    autoTable(doc, {
      startY: y,
      head: [['Match Tickets', '']],
      body: pdfMatchBody,
      theme: 'grid',
      styles: { fontSize: 10 },
      headStyles: { fillColor: [5, 150, 105], textColor: 255 },
      margin: { left: margin, right: margin },
    });
    y = doc.lastAutoTable.finalY + 16;

    // Employee Shorts
    autoTable(doc, {
      startY: y,
      head: [['Employee', 'Pulls', 'Ticket-Out', 'Short/Over']],
      body: (dayData.employees || []).map((e) => [
        e.name,
        f(e.pulls),
        f(e.ticketOut),
        f(e.shiftShort),
      ]),
      foot: [['Total', '', '', f(dayData.employeeShortsTotal)]],
      theme: 'grid',
      styles: { fontSize: 10 },
      headStyles: { fillColor: [37, 99, 235], textColor: 255 },
      footStyles: {
        fillColor: [240, 240, 245],
        textColor: 33,
        fontStyle: 'bold',
      },
      margin: { left: margin, right: margin },
    });
    y = doc.lastAutoTable.finalY + 16;

    // Equation X proof
    autoTable(doc, {
      startY: y,
      head: [['Equation X Proof', '']],
      body: [
        ['Pulls Gap', f(dayData.pullsGap)],
        ['+ Match Tickets Difference', f(dayData.matchTicketsDiff)],
        ['+ Employee Shorts Total', f(dayData.employeeShortsTotal)],
        ['= Equation X', f(dayData.equationX)],
        ['vs Weekly Report Short/Over', f(dayData.weeklyShortOver)],
        [
          'Result',
          dayData.match
            ? 'BALANCE MATCHED - DIFFERENCE IDENTIFIED'
            : 'MISMATCH — check data entry',
        ],
      ],
      theme: 'grid',
      styles: { fontSize: 10 },
      headStyles: { fillColor: [99, 102, 241], textColor: 255 },
      margin: { left: margin, right: margin },
    });
    y = doc.lastAutoTable.finalY + 30;

    // Footer
    doc.setFontSize(8).setTextColor(...C.GRAY_TEXT);
    const genDate = new Date().toLocaleString('en-US', {
      timeZone: 'America/Chicago',
    });
    doc.text(
      `Generated by NuVe System — ${genDate}`,
      margin,
      doc.internal.pageSize.getHeight() - 24
    );

    const fname = `Short Analysis - ${
      dayData.day
    } - ${new Date().getTime()}.pdf`;
    doc.save(fname);

    this.setState({ shortAnalysisPdfReady: true });
    setTimeout(() => this.setState({ shortAnalysisPdfReady: false }), 3000);
  };

  renderSummaryTable = () => {
    const { summary, employeeSummary, summaryBreakdown } = this.props;
    if (!summary || summary.length === 0) return null;

    const sb = summaryBreakdown;

    const fmt = (n) => {
      const v = n ?? 0;
      const abs = Math.round(Math.abs(v)).toLocaleString();
      return v < 0 ? `($${abs})` : `$${abs}`;
    };

    return (
      <div
        style={{
          p: { xs: 2, sm: 4 },
          width: '100%',
          height: 'calc(100vh - 300px)',
          overflowX: 'auto',
        }}
      >
        <div className="summary-container">
          <table className="summary-table">
            <thead>
              <tr>
                <th>Day</th>
                <th>Net Profit</th>
                <th>Gross Profit</th>
                <th>Short/Over</th>
                <th>Customers</th>
                <th>Total In</th>
                <th>Total Out</th>
                <th>JP Other In</th>
                <th>JP Other Out</th>
                <th>Match</th>
                <th>Match %</th>
                <th>Payout %</th>
                <th>Hold %</th>
              </tr>
            </thead>
            <tbody>
              {summary.map((row, index) => {
                const isTotalRow = row.day === 'WEEK TOTAL';
                const boldStyle = isTotalRow ? { fontWeight: 'bold' } : {};

                return (
                  <tr key={index}>
                    <td style={boldStyle} data-label="Day">
                      {row.day}
                    </td>

                    <td
                      style={boldStyle}
                      data-label="Net Profit"
                      className={row.netProfit < 0 ? 'negative' : 'positive'}
                    >
                      {row.netProfit < 0
                        ? `($${Math.abs(row.netProfit).toLocaleString()})`
                        : `$${row.netProfit.toLocaleString()}`}
                    </td>
                    <td style={boldStyle} data-label="Gross Profit">
                      ${row.grossProfit.toLocaleString()}
                    </td>
                    <td
                      style={boldStyle}
                      data-label="Short/Over"
                      className={row.shortOver < 0 ? 'negative' : ''}
                    >
                      {row.shortOver < 0
                        ? `($${Math.abs(row.shortOver).toLocaleString()})`
                        : `$${row.shortOver.toLocaleString()}`}
                    </td>
                    <td style={boldStyle} data-label="Customers">
                      {row.custCount}
                    </td>

                    <td style={boldStyle} data-label="Total In">
                      ${row.totalIn.toLocaleString()}
                    </td>
                    <td style={boldStyle} data-label="Total Out">
                      ${row.totalOut.toLocaleString()}
                    </td>
                    <td style={boldStyle} data-label="JP Other In">
                      ${row.jpOtherIn.toLocaleString()}
                    </td>
                    <td style={boldStyle} data-label="JP Other Out">
                      ${row.jpOtherOut.toLocaleString()}
                    </td>

                    <td style={boldStyle} data-label="Match">
                      ${row.matchAmount.toLocaleString()}
                    </td>

                    <td style={boldStyle} data-label="Match %">
                      {row.matchPct !== '' &&
                      row.matchPct !== null &&
                      row.matchPct !== undefined
                        ? `${row.matchPct}%`
                        : ''}
                    </td>

                    <td style={boldStyle} data-label="Payout %">
                      {row.mchPayoutPct !== '' &&
                      row.mchPayoutPct !== null &&
                      row.mchPayoutPct !== undefined
                        ? `${row.mchPayoutPct}%`
                        : ''}
                    </td>

                    <td style={boldStyle} data-label="Hold %">
                      {row.mchHoldPct !== '' &&
                      row.mchHoldPct !== null &&
                      row.mchHoldPct !== undefined
                        ? `${row.mchHoldPct}%`
                        : ''}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {sb && (
          <div
            style={{
              maxWidth: '560px',
              marginLeft: this.state.isMobile ? '0px' : '24px',
              marginRight: this.state.isMobile ? '0px' : '24px',
              width: this.state.isMobile ? '100%' : 'auto',
            }}
          >
            {/* ── Top white card ── */}
            <div
              style={{
                background: 'var(--color-background-primary)',
                border: '1px solid var(--color-border-tertiary)',
                borderRadius: 'var(--border-radius-lg)',
                padding: '20px 20px 16px',
                marginBottom: '10px',
                overflowX: 'auto',
              }}
            >
              {/* Header */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '18px',
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    color: 'black',
                  }}
                >
                  Summary Breakdown
                </p>
                <span
                  style={{
                    width: '1px',
                    height: '16px',
                    background: 'var(--color-border-tertiary)',
                  }}
                />
                <p
                  style={{
                    margin: 0,
                    fontSize: '13px',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    color: '#2471a3',
                    letterSpacing: '0.04em',
                  }}
                >
                  Manager Loan to Bank
                </p>
              </div>

              {/* 3-card row: Previous + This Week = Total */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr auto 1fr auto 1fr',
                  gap: '8px',
                  alignItems: 'center',
                  marginBottom: '14px',
                }}
              >
                <div
                  style={{
                    background: '#c0392b',
                    color: '#fff',
                    borderRadius: '6px',
                    padding: '10px 6px',
                    fontSize: '11px',
                    fontWeight: 700,
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    lineHeight: '1.3',
                  }}
                >
                  Previous Week
                  <br />
                  Manager Loan
                  <br />
                  to Bank
                </div>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: 'var(--color-text-secondary)',
                  }}
                >
                  +
                </span>
                <div
                  style={{
                    background: '#2471a3',
                    color: '#fff',
                    borderRadius: '6px',
                    padding: '10px 6px',
                    fontSize: '11px',
                    fontWeight: 700,
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    lineHeight: '1.3',
                  }}
                >
                  This Week
                  <br />
                  Manager Loan
                  <br />
                  to Bank
                </div>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: 'var(--color-text-secondary)',
                  }}
                >
                  =
                </span>
                <div
                  style={{
                    background: '#1e8449',
                    color: '#fff',
                    borderRadius: '6px',
                    padding: '10px 6px',
                    fontSize: '12px',
                    fontWeight: 700,
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    lineHeight: '1.3',
                  }}
                >
                  Total
                </div>
              </div>

              {/* Values row */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr auto 1fr auto 1fr',
                  gap: '8px',
                  alignItems: 'center',
                  marginBottom: '4px',
                }}
              >
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: 700,
                    color: '#c0392b',
                  }}
                >
                  {fmt(sb.previousWeekManagerLoan)}
                </div>
                <span
                  style={{
                    fontSize: '14px',
                    color: 'var(--color-text-secondary)',
                  }}
                >
                  +
                </span>
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: 700,
                    color: '#2471a3',
                  }}
                >
                  {fmt(sb.thisWeekManagerLoanIn)}
                </div>
                <span
                  style={{
                    fontSize: '14px',
                    color: 'var(--color-text-secondary)',
                  }}
                >
                  =
                </span>
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: 700,
                    color: '#1e8449',
                    background: '#eafaf1',
                    borderRadius: '5px',
                    padding: '6px 4px',
                  }}
                >
                  {fmt(sb.totalManagerLoan)}
                </div>
              </div>

              {/* Deductions Section */}
              <div
                style={{
                  borderTop: '1px solid var(--color-border-tertiary)',
                  marginTop: '16px',
                  paddingTop: '14px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px',
                  }}
                >
                  <span style={{ fontSize: '13px', color: 'black' }}>
                    <strong style={{ textTransform: 'uppercase' }}>
                      Deductions
                    </strong>{' '}
                    (This Week)
                  </span>
                  <span
                    style={{
                      fontSize: '14px',
                      fontWeight: 700,
                      color: '#c0392b',
                    }}
                  >
                    - {fmt(sb.thisWeekDeductions)}
                  </span>
                </div>

                <div
                  style={{
                    background: '#f5f6fa',
                    borderRadius: '6px',
                    padding: '10px 12px',
                  }}
                >
                  <div
                    style={{
                      fontSize: '12px',
                      color: '#2471a3',
                      fontWeight: 600,
                      marginBottom: '8px',
                    }}
                  >
                    Applied to This Week First, then Previous Week
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '6px 0',
                      borderBottom: '1px solid var(--color-border-tertiary)',
                      fontSize: '13px',
                    }}
                  >
                    <span style={{ color: 'var(--color-text-secondary)' }}>
                      From This Week ({fmt(sb.thisWeekManagerLoanIn)})
                    </span>
                    <span style={{ color: '#c0392b', fontWeight: 600 }}>
                      - {fmt(sb.fromThisWeekDeduction)}
                    </span>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '6px 0 0',
                      fontSize: '13px',
                    }}
                  >
                    <span style={{ color: 'var(--color-text-secondary)' }}>
                      From Previous Week ({fmt(sb.previousWeekManagerLoan)})
                    </span>
                    <span style={{ color: '#c0392b', fontWeight: 600 }}>
                      - {fmt(sb.fromPreviousWeekDeduction)}
                    </span>
                  </div>
                </div>
              </div>

              {/* Remaining Manager Loan To Bank */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: '12px',
                  padding: '12px 12px',
                  background: '#f5f6fa',
                  borderRadius: '6px',
                }}
              >
                <span
                  style={{
                    fontSize: '13px',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    color: 'black',
                  }}
                >
                  Remaining Manager Loan to Bank
                </span>
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: 700,
                    color: '#1e8449',
                    background: '#eafaf1',
                    padding: '5px 10px',
                    borderRadius: '5px',
                  }}
                >
                  {fmt(sb.remainingManagerLoan)}
                </span>
              </div>
            </div>

            {/* ── Bottom dark card ── */}
            <div
              style={{
                background: '#1a2f5a',
                borderRadius: 'var(--border-radius-lg)',
                padding: '18px 20px 20px',
              }}
            >
              {/* Net Profit */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 0',
                  borderBottom: '1px solid rgba(255,255,255,0.10)',
                }}
              >
                <span
                  style={{ fontSize: '14px', color: 'rgba(255,255,255,0.85)' }}
                >
                  Net Profit (This Week)
                </span>
                <span
                  style={{ fontSize: '15px', fontWeight: 500, color: '#fff' }}
                >
                  {fmt(sb.weekNetProfit)}
                </span>
              </div>

              {/* Adjustments */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 0',
                  borderBottom: '1px solid rgba(255,255,255,0.10)',
                }}
              >
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '7px' }}
                >
                  <span
                    style={{
                      fontSize: '14px',
                      color: 'rgba(255,255,255,0.85)',
                    }}
                  >
                    Adjustments
                  </span>
                </div>
                <span
                  style={{
                    fontSize: '15px',
                    fontWeight: 500,
                    color: sb.adjustment < 0 ? '#2ecc71' : '#e74c3c',
                  }}
                >
                  {sb.adjustment < 0
                    ? `+ $${Math.round(sb.adjustment).toLocaleString()}`
                    : `– ($${Math.round(
                        Math.abs(sb.adjustment)
                      ).toLocaleString()})`}
                </span>
              </div>

              {/* Available to Approve */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  paddingTop: '16px',
                }}
              >
                <span
                  style={{ fontSize: '15px', fontWeight: 500, color: '#fff' }}
                >
                  Total Net Profit:
                </span>
                <span
                  style={{
                    fontSize: '22px',
                    fontWeight: 500,
                    color: sb.availableToApprove < 0 ? '#e74c3c' : '#2ecc71',
                  }}
                >
                  {fmt(sb.availableToApprove)}
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="summary-container" style={{ marginTop: '24px' }}>
          <table className="summary-table">
            <thead>
              <tr>
                <th>Day</th>
                <th>Short/Over</th>
                <th>Employee Names</th>
                <th>Zelle</th>
                <th>Receive By</th>
              </tr>
            </thead>
            <tbody>
              {employeeSummary?.map((row, index) => {
                const isTotalRow = row.day === 'WEEK TOTAL';
                const boldStyle = isTotalRow ? { fontWeight: 'bold' } : {};

                return (
                  <tr key={index}>
                    <td style={boldStyle} data-label="Day">
                      {row.day}
                    </td>

                    <td
                      style={boldStyle}
                      data-label="Short/Over"
                      className={row.shortOver < 0 ? 'negative' : ''}
                    >
                      {row.shortOver < 0
                        ? `($${Math.abs(row.shortOver).toLocaleString()})`
                        : `$${row.shortOver.toLocaleString()}`}
                    </td>

                    <td style={boldStyle} data-label="Employee Names">
                      {row.employeeNames?.map((emp) => emp.name).join(', ') ||
                        ''}
                    </td>

                    <td style={boldStyle} data-label="Zelle">
                      {row.zelle != null
                        ? `$${row.zelle.toLocaleString()}`
                        : ''}
                    </td>

                    <td style={boldStyle} data-label="Receive By">
                      {row.receiveBy?.join(', ') || ''}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // Tuesday check
  isTuesday = (date) => date.getDay() === 2;

  // Get Monday after the given Tuesday
  getMondayFromTuesday = (tuesdayDate) => {
    const monday = new Date(tuesdayDate);
    monday.setDate(tuesdayDate.getDate() + 6);
    return monday;
  };

  // Handle 'fromDate' (must be Tuesday)
  handleFromDateChange = (date) => {
    if (!date || !this.isTuesday(date)) return;

    const toDate = this.getMondayFromTuesday(date);
    this.setState({
      fromDate: date,
      toDate,
    });
  };

  // Handle 'toDate' (must match the Monday after fromDate)
  handleToDateChange = (date) => {
    if (!date) return;

    const { fromDate } = this.state;
    if (!fromDate) return;

    const validMonday = this.getMondayFromTuesday(fromDate);
    if (date.toDateString() !== validMonday.toDateString()) return;

    this.setState({ toDate: date });
  };

  handleAddExpense = () => {
    const { newExpense } = this.state;
    const { report } = this.props;
    const { selectedDay } = this.state;

    const selectedReport = report[selectedDay] || {};
    const expenseSet = [...(selectedReport.expenseSet || [])];

    const totalIndex = expenseSet.findIndex(
      (e) => e.description?.toLowerCase() === 'total'
    );

    const expenseToAdd = {
      ...newExpense,
      amount: parseFloat(newExpense.amount) || 0,
      isManager: true,
    };

    // Insert before total or at end if not found
    if (totalIndex >= 0) {
      expenseSet.splice(totalIndex, 0, expenseToAdd);
    } else {
      expenseSet.push(expenseToAdd);
    }

    // Update total if it exists
    const totalAmount = expenseSet
      .filter((e) => e.description?.toLowerCase() !== 'total')
      .reduce((sum, e) => sum + (parseFloat(e.amount) || 0), 0);

    const updatedSet = expenseSet.map((e) =>
      e.description?.toLowerCase() === 'total'
        ? { ...e, amount: totalAmount }
        : e
    );

    const callback = (success, message) => {
      if (!success) {
        this.openFeedbackBar('error', message);
      } else {
        this.setState({
          showAddExpenseDialog: false,
          newExpense: {
            description: '',
            expenseType: '',
            amount: '',
            comments: '',
          },
        });

        this.refreshComponent(this.state.selectedSessionIds);
      }
    };

    this.props.updateReportField(
      selectedReport.sessionIds,
      'expenseSet',
      updatedSet,
      this.props.userInfo.selectedLocationId,
      callback
    );
  };

  handleDeleteExpense = () => {
    const { rowToDelete } = this.state;
    const { report } = this.props;
    const { selectedDay } = this.state;

    const selectedReport = report[selectedDay] || {};
    const expenseSet = [...(selectedReport.expenseSet || [])];

    if (
      rowToDelete !== null &&
      rowToDelete >= 0 &&
      rowToDelete < expenseSet.length
    ) {
      expenseSet.splice(rowToDelete, 1);
    }

    // Recalculate total
    const totalAmount = expenseSet
      .filter((e) => e.description?.toLowerCase() !== 'total')
      .reduce((sum, e) => sum + (parseFloat(e.amount) || 0), 0);

    const updatedSet = expenseSet.map((e) =>
      e.description?.toLowerCase() === 'total'
        ? { ...e, amount: totalAmount }
        : e
    );

    const callback = (success, message) => {
      if (!success) {
        this.openFeedbackBar('error', message);
      } else {
        this.refreshComponent(this.state.selectedSessionIds);
      }
    };

    this.props.updateReportField(
      selectedReport.sessionIds,
      'expenseSet',
      updatedSet,
      this.props.userInfo.selectedLocationId,
      callback
    );

    this.setState({
      showDeleteDialog: false,
      rowToDelete: null,
    });
  };

  renderManagerSetting = () => {
    return (
      <ManagerSetting
        userInfo={this.props.userInfo}
        isBack={this.isBack}
        managerSetting={this.props.managerSetting}
        saveManagerSetting={this.props.saveManagerSetting}
        getManagerSummary={this.props.getManagerSummary}
      />
    );
  };

  isBack = () => {
    this.setState({ isSettings: false });
  };

  isManager = () => {
    const { userInfo } = this.props;
    const roles = userInfo?.authority || [];
    return roles.includes('ROLE_ADMIN');
  };

  fmt = (val) => (val == null ? '$0' : `$${Number(val).toLocaleString()}`);

  // ────────────────────────────────────────────────────────────
  // PDF DOWNLOAD (client-side, jsPDF + autoTable)
  // ────────────────────────────────────────────────────────────
  pdfFmt = (v) => {
    const n = Number(v) || 0;
    return n < 0
      ? `($${Math.abs(n).toLocaleString()})`
      : `$${n.toLocaleString()}`;
  };

  buildProfitRows = (r) => {
    const totalExpenses = (r.expenseSet || [])
      .filter((i) => i.description !== 'Total')
      .reduce((s, i) => s + (i.amount || 0), 0);
    const computedTotalIn =
      (r.openingBalance || 0) +
      (r.totalIn || 0) +
      (r.jpOtherIn || 0) +
      (r.employeeShortPay || 0) +
      (r.loanIn || 0) +
      (r.addBank || 0);
    const computedReadingOut =
      (r.totalOut || 0) + (r.jpOtherOut || 0) - (r.jackpotNotPay || 0);
    const computedTotalOut =
      computedReadingOut + (r.minusBank || 0) + (totalExpenses || 0);
    const difference = computedTotalIn - computedTotalOut;

    return [
      ['Opening Balance', this.pdfFmt(r.openingBalance)],
      ['Reading Total IN', this.pdfFmt((r.totalIn || 0) + (r.jpOtherIn || 0))],
      ['Employee Short Payment', this.pdfFmt(r.employeeShortPay)],
      ['Loan In', this.pdfFmt(r.loanIn)],
      ['Add Bank', this.pdfFmt(r.addBank)],
      ['Total IN', this.pdfFmt(computedTotalIn)],
      ['Reading Total OUT', this.pdfFmt(computedReadingOut)],
      ['Minus Bank', this.pdfFmt(r.minusBank)],
      ['All Expenses', this.pdfFmt(totalExpenses)],
      ['Total OUT', this.pdfFmt(computedTotalOut)],
      ['Difference', this.pdfFmt(difference)],
      ['Ending Balance', this.pdfFmt(r.endingBalance)],
      ['Short / Over', this.pdfFmt(r.shortOver)],
      ['Net Profit', this.pdfFmt(r.netProfit)],
      ['Customers', String(r.customers?.length || 0)],
    ];
  };

  downloadWeeklyPdf = (mode) => {
    const { report, summary, employeeSummary, summaryBreakdown, userInfo } =
      this.props;
    const { selectedDay, fromDate, toDate } = this.state;
    const locName = userInfo?.selectedLocationName || 'NUVE SYSTEM';
    const C = PDF_COLORS;

    const formatDateShort = (d) => {
      if (!d) return '';
      return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    };

    const formatDateLong = (d) => {
      if (!d) return '';
      return d.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    };

    const dateRangeStr = `${formatDateShort(fromDate)} – ${formatDateShort(
      toDate
    )}`;

    const doc = new jsPDF({ unit: 'pt', format: 'letter' });
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const margin = 40;
    const contentW = pageW - margin * 2;

    // ── format helpers ──
    const pf = (v) => {
      const n = Number(v) || 0;
      return n < 0
        ? `($${Math.abs(n).toLocaleString()})`
        : `$${n.toLocaleString()}`;
    };

    const fmtRound = (n) => {
      const v = n ?? 0;
      const abs = Math.round(Math.abs(v)).toLocaleString();
      return v < 0 ? `($${abs})` : `$${abs}`;
    };

    const now = new Date();
    const genDate =
      now.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      }) +
      ' ' +
      now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

    let pageNum = 0;

    // ── page chrome (header bar + footer) ──
    const drawChrome = (sub) => {
      pageNum++;
      doc.setFillColor(...C.BLUE_HEADER);
      doc.rect(0, 0, pageW, 38, 'F');
      doc
        .setFont('helvetica', 'bold')
        .setFontSize(13)
        .setTextColor(...C.WHITE);
      doc.text(locName, margin, 25);
      doc.setFont('helvetica', 'normal').setFontSize(9);
      doc.text(sub, pageW - margin, 25, { align: 'right' });
      doc.setDrawColor(180, 180, 180).setLineWidth(0.5);
      doc.line(margin, pageH - 36, pageW - margin, pageH - 36);
      doc.setFontSize(8).setTextColor(...C.GRAY_TEXT);
      doc.text(`${locName} · Generated ${genDate}`, margin, pageH - 24);
      doc.text(`Page ${pageNum}`, pageW - margin, pageH - 24, {
        align: 'right',
      });
    };

    let subtitle = '';

    const newPage = () => {
      doc.addPage();
      drawChrome(subtitle);
    };

    // ── coloured section heading ──
    const heading = (title, y, color = C.BLUE_SECTION) => {
      doc
        .setFont('helvetica', 'bold')
        .setFontSize(13)
        .setTextColor(...color);
      doc.text(title, margin, y);
      return y + 6;
    };

    // ── generic styled table ──
    const table = (body, startY, opts = {}) => {
      const { amtColor, totalLabel, threeCol, headRow } = opts;

      autoTable(doc, {
        startY,
        head: headRow ? [headRow] : undefined,
        body,
        theme: 'plain',
        showHead: headRow ? 'firstPage' : false,
        margin: { left: margin, right: margin },
        tableWidth: contentW,
        styles: {
          fontSize: 10,
          cellPadding: { top: 7, bottom: 7, left: 10, right: 10 },
          lineWidth: 0,
          textColor: C.DARK_TEXT,
          font: 'helvetica',
        },
        headStyles: headRow
          ? {
              fillColor: [240, 240, 245],
              textColor: C.GRAY_TEXT,
              fontStyle: 'bold',
              fontSize: 9,
            }
          : undefined,
        columnStyles: threeCol
          ? {
              0: { cellWidth: 70, fontStyle: 'bold' },
              1: { cellWidth: 'auto' },
              2: { halign: 'right', cellWidth: 90 },
            }
          : {
              0: { cellWidth: 'auto' },
              1: { halign: 'right', cellWidth: 110 },
            },
        alternateRowStyles: { fillColor: C.LIGHT_BG },

        didParseCell: (data) => {
          if (data.section !== 'body') return;
          const idx = data.row.index;
          const col = data.column.index;
          const last = idx === body.length - 1;
          const raw = (data.cell.raw || '').toString();
          const amtCol = threeCol ? 2 : 1;

          if (last && totalLabel) {
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.fontSize = 11;
          }
          if (col === amtCol && amtColor) {
            data.cell.styles.textColor = amtColor;
          }
          if (raw.startsWith('(') || raw.startsWith('-$')) {
            data.cell.styles.textColor = C.RED_OUT;
          }
          if (threeCol && col === 0) {
            const t = raw.toLowerCase();
            if (t.includes('loan') || t === '+')
              data.cell.styles.textColor = C.GREEN_IN;
            if (t.includes('minus') || t === '-')
              data.cell.styles.textColor = C.RED_OUT;
          }
        },

        didDrawCell: (data) => {
          if (data.section !== 'body') return;
          if (data.row.index === body.length - 1 && totalLabel) {
            doc.setDrawColor(200, 60, 60).setLineWidth(1.2);
            doc.line(
              data.cell.x,
              data.cell.y,
              data.cell.x + data.cell.width,
              data.cell.y
            );
          }
        },
      });

      return doc.lastAutoTable.finalY;
    };

    // ── balance-check cards ──
    const balanceCheck = (y, expected, ending, shortOver, netProfit) => {
      const cx = pageW / 2;
      const cardX = margin + 60;
      const cardW = contentW - 120;

      doc
        .setFont('helvetica', 'bold')
        .setFontSize(9)
        .setTextColor(150, 150, 150);
      const lbl = 'BALANCE CHECK';
      const lw = doc.getTextWidth(lbl);
      doc.setFillColor(180, 180, 180);
      doc.rect(cx - lw / 2 - 80, y + 3, 75, 6, 'F');
      doc.rect(cx + lw / 2 + 5, y + 3, 75, 6, 'F');
      doc.text(lbl, cx, y + 10, { align: 'center' });
      y += 24;

      const card = (yy, cardTitle, cardSub, val) => {
        doc.setFillColor(...C.BALANCE_BG);
        doc.roundedRect(cardX, yy, cardW, 40, 3, 3, 'F');
        doc.setDrawColor(200, 200, 220).setLineWidth(0.5);
        doc.roundedRect(cardX, yy, cardW, 40, 3, 3, 'S');
        doc.setFillColor(80, 90, 210);
        doc.rect(cardX, yy, 4, 40, 'F');
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(10)
          .setTextColor(...C.DARK_TEXT);
        doc.text(cardTitle, cardX + 14, yy + 16);
        doc
          .setFont('helvetica', 'normal')
          .setFontSize(8)
          .setTextColor(...C.GRAY_TEXT);
        doc.text(cardSub, cardX + 14, yy + 28);
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(16)
          .setTextColor(...C.DARK_TEXT);
        doc.text(pf(val), cardX + cardW - 14, yy + 26, { align: 'right' });
      };

      card(y, 'Difference', 'Money In - Money Out', expected);
      y += 48;
      card(y, 'Ending Balance', 'Cash counted at close', ending);
      y += 48;

      doc.setFillColor(245, 245, 248);
      doc.roundedRect(cardX - 20, y, cardW + 40, 28, 3, 3, 'F');
      doc
        .setFont('helvetica', 'bold')
        .setFontSize(10)
        .setTextColor(...C.DARK_TEXT);
      doc.text('Short / Over', cardX - 10, y + 18);
      doc
        .setTextColor(...(shortOver < 0 ? C.RED_OUT : C.GREEN_IN))
        .setFontSize(12);
      doc.text(pf(shortOver), cardX + cardW + 20, y + 18, { align: 'right' });
      y += 38;

      doc
        .setFont('helvetica', 'bold')
        .setFontSize(13)
        .setTextColor(...C.GREEN_IN);
      doc.text('NET PROFIT', cardX - 10, y + 23);
      doc
        .setFontSize(20)
        .setTextColor(...(netProfit < 0 ? C.RED_OUT : C.GREEN_IN));
      doc.text(pf(netProfit), cardX + cardW + 20, y + 25, { align: 'right' });
      return y + 48;
    };

    // ── employees + notes section ──
    const empNotes = (y, r) => {
      if (y > pageH - 120) {
        newPage();
        y = 56;
      }
      const emps = r.employeeDetails || [];
      if (emps.length) {
        doc
          .setFont('helvetica', 'normal')
          .setFontSize(9)
          .setTextColor(...C.DARK_TEXT);
        const line =
          'EMPLOYEES ON SHIFT: ' +
          emps
            .map((e) => `${(e.name || '').toUpperCase()} (${e.timeIn || ''})`)
            .join(' · ');
        const lines = doc.splitTextToSize(line, contentW);
        doc.text(lines, margin, y);
        y += lines.length * 12 + 10;
      }
      if (y < pageH - 80) {
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(9)
          .setTextColor(...C.DARK_TEXT);
        doc.text('NOTES:', margin, y);
        y += 6;
        doc.setDrawColor(200, 200, 200).setLineWidth(0.5);
        doc.roundedRect(margin, y, contentW, 50, 4, 4, 'S');
      }
      return y + 60;
    };

    const ensureSpace = (need) => {
      if (y + need > pageH - 60) {
        newPage();
        y = 56;
      }
    };

    // ══════════════════════════════════════════════════════════
    //  BUILD THE PDF
    // ══════════════════════════════════════════════════════════
    const r = (report && selectedDay && report[selectedDay]) || {};
    const totalExpenses = (r.expenseSet || [])
      .filter((i) => i.description !== 'Total')
      .reduce((s, i) => s + (i.amount || 0), 0);
    const realIn = (r.totalIn || 0) + (r.jpOtherIn || 0);
    const realOut =
      (r.totalOut || 0) + (r.jpOtherOut || 0) - (r.jackpotNotPay || 0);
    const computedTotalIn =
      (r.openingBalance || 0) +
      realIn +
      (r.employeeShortPay || 0) +
      (r.loanIn || 0) +
      (r.addBank || 0);
    const computedTotalOut = realOut + (r.minusBank || 0) + totalExpenses;
    const difference = computedTotalIn - computedTotalOut;
    const custCount = r.customers?.length || 0;
    const dayLabel = selectedDay || '';

    // ══════════════════════════════════════════════════════════
    //  SUMMARY MODE — includes all 3 sections
    // ══════════════════════════════════════════════════════════
    if (mode === 'summary') {
      subtitle = `Weekly Summary — ${dateRangeStr}`;
      drawChrome(subtitle);
      let y = 64;
      doc
        .setFont('helvetica', 'bold')
        .setFontSize(18)
        .setTextColor(...C.DARK_TEXT);
      doc.text('Complete Weekly Summary', pageW / 2, y, { align: 'center' });
      y += 14;
      doc
        .setFont('helvetica', 'normal')
        .setFontSize(10)
        .setTextColor(...C.GRAY_TEXT);
      doc.text(dateRangeStr, pageW / 2, y, { align: 'center' });
      y += 20;

      // ────────────────────────────────────────────
      // 1. MAIN SUMMARY TABLE
      // ────────────────────────────────────────────
      if (summary?.length) {
        const head = [
          'Day',
          'Net Profit',
          'Gross',
          'Short/Over',
          'Total In',
          'Total Out',
          'JP In',
          'JP Out',
          'Cust',
          'Match',
          'Match%',
          'Payout%',
          'Hold%',
        ];
        const body = summary.map((row) => [
          row.day,
          pf(row.netProfit),
          pf(row.grossProfit),
          pf(row.shortOver),
          pf(row.totalIn),
          pf(row.totalOut),
          pf(row.jpOtherIn),
          pf(row.jpOtherOut),
          String(row.custCount || 0),
          pf(row.matchAmount),
          row.matchPct != null ? `${row.matchPct}%` : '',
          row.mchPayoutPct != null ? `${row.mchPayoutPct}%` : '',
          row.mchHoldPct != null ? `${row.mchHoldPct}%` : '',
        ]);
        autoTable(doc, {
          startY: y,
          head: [head],
          body,
          theme: 'grid',
          headStyles: {
            fillColor: C.BLUE_HEADER,
            textColor: C.WHITE,
            fontSize: 7,
            fontStyle: 'bold',
            cellPadding: 4,
          },
          styles: { fontSize: 7, cellPadding: 3 },
          alternateRowStyles: { fillColor: C.LIGHT_BG },
          margin: { left: 20, right: 20 },
          didParseCell: (data) => {
            if (data.section !== 'body') return;
            const raw = (data.cell.raw || '').toString();
            if (raw.startsWith('(') || raw.startsWith('-$'))
              data.cell.styles.textColor = C.RED_OUT;
            if (data.row.raw?.[0] === 'WEEK TOTAL')
              data.cell.styles.fontStyle = 'bold';
          },
        });
        y = doc.lastAutoTable.finalY + 24;
      }

      // ────────────────────────────────────────────
      // 2. SUMMARY BREAKDOWN
      // ────────────────────────────────────────────
      const sb = summaryBreakdown;
      if (sb) {
        // Check if we need a new page
        if (y + 220 > pageH - 60) {
          newPage();
          y = 56;
        }

        y = heading(
          'SUMMARY BREAKDOWN  |  MANAGER LOAN TO BANK',
          y,
          C.DARK_TEXT
        );
        y += 8;

        const breakdownX = margin;
        const breakdownW = Math.min(contentW, 520);
        const colW = breakdownW / 5;
        const colX = (i) => breakdownX + colW * i;

        // Header pills row: Prev Week | + | This Week | = | Total
        const drawPill = (x, w, label1, label2, bgColor) => {
          doc.setFillColor(...bgColor);
          doc.roundedRect(x + 2, y, w - 4, 38, 4, 4, 'F');
          doc
            .setFont('helvetica', 'bold')
            .setFontSize(7)
            .setTextColor(...C.WHITE);
          if (label2) {
            doc.text(label1, x + w / 2, y + 16, { align: 'center' });
            doc.text(label2, x + w / 2, y + 28, { align: 'center' });
          } else {
            doc.text(label1, x + w / 2, y + 22, { align: 'center' });
          }
        };

        drawPill(
          colX(0),
          colW,
          'PREVIOUS WEEK',
          'MANAGER LOAN TO BANK',
          [192, 57, 43]
        );
        drawPill(
          colX(2),
          colW,
          'THIS WEEK',
          'MANAGER LOAN TO BANK',
          [36, 113, 163]
        );
        drawPill(colX(4), colW, 'TOTAL', '', [30, 132, 73]);

        // operator signs
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(12)
          .setTextColor(...C.GRAY_TEXT);
        doc.text('+', colX(1) + colW / 2, y + 22, { align: 'center' });
        doc.text('=', colX(3) + colW / 2, y + 22, { align: 'center' });
        y += 46;

        // Values row
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(11)
          .setTextColor(192, 57, 43);
        doc.text(fmtRound(sb.previousWeekManagerLoan), colX(0) + colW / 2, y, {
          align: 'center',
        });
        doc.setTextColor(36, 113, 163);
        doc.text(fmtRound(sb.thisWeekManagerLoanIn), colX(2) + colW / 2, y, {
          align: 'center',
        });
        // Total pill
        doc.setFillColor(234, 250, 241);
        doc.roundedRect(colX(4) + 4, y - 11, colW - 8, 18, 4, 4, 'F');
        doc.setTextColor(30, 132, 73);
        doc.text(fmtRound(sb.totalManagerLoan), colX(4) + colW / 2, y, {
          align: 'center',
        });
        y += 20;

        // Divider
        doc.setDrawColor(220, 220, 220).setLineWidth(0.5);
        doc.line(breakdownX, y, breakdownX + breakdownW, y);
        y += 14;

        // DEDUCTIONS (This Week) row
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(10)
          .setTextColor(...C.DARK_TEXT);
        doc.text('DEDUCTIONS', breakdownX, y);
        doc
          .setFont('helvetica', 'normal')
          .setFontSize(10)
          .setTextColor(...C.GRAY_TEXT);
        doc.text('(This Week)', breakdownX + 70, y);
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(11)
          .setTextColor(192, 57, 43);
        doc.text(
          `- ${fmtRound(sb.thisWeekDeductions)}`,
          breakdownX + breakdownW,
          y,
          { align: 'right' }
        );
        y += 10;

        // Applied to box
        doc.setFillColor(245, 246, 250);
        doc.roundedRect(breakdownX, y, breakdownW, 50, 4, 4, 'F');
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(8)
          .setTextColor(36, 113, 163);
        doc.text(
          'Applied to This Week First, then Previous Week',
          breakdownX + 8,
          y + 12
        );
        doc
          .setFont('helvetica', 'normal')
          .setFontSize(9)
          .setTextColor(...C.GRAY_TEXT);
        doc.text(
          `From This Week (${fmtRound(sb.thisWeekManagerLoanIn)})`,
          breakdownX + 8,
          y + 26
        );
        doc.setTextColor(192, 57, 43).setFont('helvetica', 'bold');
        doc.text(
          `- ${fmtRound(sb.fromThisWeekDeduction)}`,
          breakdownX + breakdownW - 8,
          y + 26,
          { align: 'right' }
        );
        doc.setFont('helvetica', 'normal').setTextColor(...C.GRAY_TEXT);
        doc.text(
          `From Previous Week (${fmtRound(sb.previousWeekManagerLoan)})`,
          breakdownX + 8,
          y + 40
        );
        doc.setTextColor(192, 57, 43).setFont('helvetica', 'bold');
        doc.text(
          `- ${fmtRound(sb.fromPreviousWeekDeduction)}`,
          breakdownX + breakdownW - 8,
          y + 40,
          { align: 'right' }
        );
        y += 60;

        // Remaining Manager Loan To Bank
        doc.setFillColor(245, 246, 250);
        doc.roundedRect(breakdownX, y, breakdownW, 28, 4, 4, 'F');
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(10)
          .setTextColor(...C.DARK_TEXT);
        doc.text('REMAINING MANAGER LOAN TO BANK', breakdownX + 8, y + 18);
        doc.setFillColor(234, 250, 241);
        doc.roundedRect(breakdownX + breakdownW - 90, y + 6, 82, 16, 4, 4, 'F');
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(10)
          .setTextColor(30, 132, 73);
        doc.text(
          fmtRound(sb.remainingManagerLoan),
          breakdownX + breakdownW - 8,
          y + 18,
          { align: 'right' }
        );
        y += 40;

        y += 8;

        // ── Dark navy card (Net Profit, Adjustments, Total) ──
        if (y + 120 > pageH - 60) {
          newPage();
          y = 56;
        }

        const cardX = margin;
        const cardW = Math.min(contentW, 520);
        const cardH = 110;

        doc.setFillColor(...C.DARK_NAVY);
        doc.roundedRect(cardX, y, cardW, cardH, 6, 6, 'F');

        let cy = y + 20;

        // Net Profit row

        doc
          .setFont('helvetica', 'normal')
          .setFontSize(10)
          .setTextColor(...C.WHITE);
        doc.text('Net Profit (This Week)', cardX + 16, cy);
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(11)
          .setTextColor(...C.WHITE);
        doc.text(fmtRound(sb.weekNetProfit), cardX + cardW - 16, cy, {
          align: 'right',
        });

        // Divider line
        cy += 12;
        doc.setDrawColor(50, 65, 110); // slightly lighter than navy to simulate transparency
        doc.setLineWidth(0.5);
        doc.line(cardX + 16, cy, cardX + cardW - 16, cy);
        cy += 16;

        // Adjustments row
        doc
          .setFont('helvetica', 'normal')
          .setFontSize(10)
          .setTextColor(...C.WHITE);
        doc.text('Adjustments', cardX + 16, cy);

        const adjVal = sb.adjustment || 0;
        const adjColor = adjVal < 0 ? [46, 204, 113] : [231, 76, 60]; // green if negative (addition), red if positive (deduction)
        const adjText =
          adjVal < 0
            ? `+ $${Math.round(Math.abs(adjVal)).toLocaleString()}`
            : `– ($${Math.round(Math.abs(adjVal)).toLocaleString()})`;
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(11)
          .setTextColor(...adjColor);
        doc.text(adjText, cardX + cardW - 16, cy, { align: 'right' });

        // Divider
        cy += 12;
        doc.setDrawColor(50, 65, 110);
        doc.setLineWidth(0.5);
        doc.line(cardX + 16, cy, cardX + cardW - 16, cy);
        cy += 20;

        // Total Net Profit row
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(11)
          .setTextColor(...C.WHITE);
        doc.text('Total Net Profit:', cardX + 16, cy);

        const totalNetProfit = sb.availableToApprove || 0;
        const totalColor = totalNetProfit < 0 ? [231, 76, 60] : [46, 204, 113];
        doc
          .setFont('helvetica', 'bold')
          .setFontSize(16)
          .setTextColor(...totalColor);
        doc.text(fmtRound(totalNetProfit), cardX + cardW - 16, cy + 2, {
          align: 'right',
        });

        y += cardH + 24;
      }

      // ────────────────────────────────────────────
      // 3. EMPLOYEE SUMMARY TABLE
      // ────────────────────────────────────────────
      if (employeeSummary?.length) {
        if (y + 100 > pageH - 60) {
          newPage();
          y = 56;
        }

        y += 4;

        const empHead = [
          'Day',
          'Short/Over',
          'Employee Names',
          'Zelle',
          'Receive By',
        ];
        const empBody = employeeSummary.map((row) => [
          row.day || '',
          row.shortOver < 0
            ? `($${Math.abs(row.shortOver).toLocaleString()})`
            : `$${(row.shortOver || 0).toLocaleString()}`,
          row.employeeNames?.map((emp) => emp.name).join(', ') || '',
          row.zelle != null ? `$${row.zelle.toLocaleString()}` : '',
          row.receiveBy?.join(', ') || '',
        ]);

        autoTable(doc, {
          startY: y,
          head: [empHead],
          body: empBody,
          theme: 'grid',
          headStyles: {
            fillColor: C.BLUE_HEADER,
            textColor: C.WHITE,
            fontSize: 8,
            fontStyle: 'bold',
            cellPadding: 5,
          },
          styles: { fontSize: 8, cellPadding: 4 },
          alternateRowStyles: { fillColor: C.LIGHT_BG },
          margin: { left: margin, right: margin },
          columnStyles: {
            0: { cellWidth: 70 },
            1: { cellWidth: 70, halign: 'right' },
            2: { cellWidth: 'auto' },
            3: { cellWidth: 60, halign: 'right' },
            4: { cellWidth: 80 },
          },
          didParseCell: (data) => {
            if (data.section !== 'body') return;
            const raw = (data.cell.raw || '').toString();
            // Negatives in red
            if (raw.startsWith('(') || raw.startsWith('-$'))
              data.cell.styles.textColor = C.RED_OUT;
            // Bold the WEEK TOTAL row
            if (data.row.raw?.[0] === 'WEEK TOTAL')
              data.cell.styles.fontStyle = 'bold';
          },
        });
      }

      Utils.handlePdfAction(
        doc.output('arraybuffer'),
        'download',
        `Weekly_Summary_${formatDateShort(fromDate).replace(
          /[\s,]+/g,
          '_'
        )}_to_${formatDateShort(toDate).replace(/[\s,]+/g, '_')}.pdf`
      );
      return;
    }

    // ══════════════════════════════════════════════════════════
    //  QUICK / FULL (day report)
    // ══════════════════════════════════════════════════════════
    subtitle = `Weekly Report — Week ending ${formatDateShort(toDate)}`;
    drawChrome(subtitle);
    let y = 64;

    const title =
      mode === 'quick'
        ? 'WEEKLY CASH FLOW — QUICK SUMMARY'
        : 'WEEKLY REPORT — FULL DETAIL';
    doc
      .setFont('helvetica', 'bold')
      .setFontSize(20)
      .setTextColor(...C.DARK_TEXT);
    doc.text(title, pageW / 2, y, { align: 'center' });
    y += 16;
    doc
      .setFont('helvetica', 'normal')
      .setFontSize(10)
      .setTextColor(...C.GRAY_TEXT);
    doc.text(
      `${dayLabel} · Week ending ${formatDateLong(
        toDate
      )} · ${custCount} Customers`,
      pageW / 2,
      y,
      { align: 'center' }
    );
    y += 24;

    // ── MONEY IN ──
    y = heading('MONEY IN', y, C.GREEN_IN);
    const inRows = [];
    inRows.push(['Opening Balance', pf(r.openingBalance)]);
    inRows.push(['Total IN (machines)', pf(realIn)]);
    if ((r.employeeShortPay || 0) !== 0)
      inRows.push(['Employee Short Payment', pf(r.employeeShortPay)]);
    if ((r.loanIn || 0) !== 0) inRows.push(['Loan In', pf(r.loanIn)]);
    if ((r.addBank || 0) !== 0) inRows.push(['Add Bank', pf(r.addBank)]);
    inRows.push(['TOTAL MONEY IN', pf(computedTotalIn)]);
    y = table(inRows, y + 4, {
      amtColor: C.DARK_TEXT,
      totalLabel: 'TOTAL MONEY IN',
    });
    y += 16;

    // ── MONEY OUT ──
    y = heading('MONEY OUT', y, C.RED_OUT);
    const outRows = [
      ['Total Expenses', pf(totalExpenses)],
      ['Total OUT (machine payouts)', pf(realOut)],
    ];
    if ((r.minusBank || 0) !== 0) outRows.push(['Minus Bank', pf(r.minusBank)]);
    outRows.push(['TOTAL MONEY OUT', pf(computedTotalOut)]);
    y = table(outRows, y + 4, {
      amtColor: C.DARK_TEXT,
      totalLabel: 'TOTAL MONEY OUT',
    });
    y += 20;

    // ── BALANCE CHECK ──
    y = balanceCheck(
      y,
      difference,
      r.endingBalance || 0,
      r.shortOver || 0,
      r.netProfit || 0
    );

    // ── QUICK → done ──
    if (mode === 'quick') {
      y = empNotes(y, r);
      Utils.handlePdfAction(
        doc.output('arraybuffer'),
        'download',
        `Quick_Summary_${dayLabel}_${formatDateShort(toDate).replace(
          /[\s,]+/g,
          '_'
        )}.pdf`
      );
      return;
    }

    // ══════════════════════════════════════════════════════════
    //  FULL REPORT — additional pages
    // ══════════════════════════════════════════════════════════

    // ── MACHINE READINGS ──
    newPage();
    y = 56;
    y = heading('READINGS', y, C.BLUE_SECTION);
    y = table(
      [
        ['Total IN', pf(r.totalIn)],
        ['Total OUT', pf(r.totalOut)],
        ['JP / Other In', pf(r.jpOtherIn)],
        ['JP / Other Out', pf(r.jpOtherOut)],
        ['Jackpot Not Pay', pf(r.jackpotNotPay)],
        ['GROSS PROFIT', pf(r.grossProfit)],
      ],
      y + 4,
      { totalLabel: 'GROSS PROFIT', amtColor: C.DARK_TEXT }
    );
    y += 20;

    // ── METER PULLS ──
    y = heading('METER PULLS', y, C.TEAL_CUST);
    const pullDiff = Math.abs((r.morningPull || 0) - (r.nightPull || 0));
    y = table(
      [
        ['Morning Pull', (r.morningPull || 0).toLocaleString()],
        ['Night Pull', (r.nightPull || 0).toLocaleString()],
        ['Difference', pullDiff.toLocaleString()],
      ],
      y + 4,
      { amtColor: C.TEAL_CUST }
    );
    y += 20;

    // ── CUSTOMER COUNT ──
    y = heading('CUSTOMER COUNT', y, C.BLUE_SECTION);
    y = table([['Total Customers', String(custCount)]], y + 4, {
      amtColor: C.TEAL_CUST,
    });
    y += 20;

    // ── ALL EXPENSES ──
    ensureSpace(200);
    y = heading('ALL EXPENSES', y, C.ORANGE_EXP);
    const expRows = (r.expenseSet || [])
      .filter((e) => e.description?.toLowerCase() !== 'total')
      .filter((e) => (e.amount || 0) !== 0)
      .map((e) => [e.description || '', pf(e.amount)]);
    expRows.push(['TOTAL EXPENSES', pf(totalExpenses)]);
    y = table(expRows, y + 4, {
      amtColor: C.ORANGE_EXP,
      totalLabel: 'TOTAL EXPENSES',
    });

    // ── CLOSING BALANCE ──
    newPage();
    y = 56;
    y = heading('CLOSING BALANCE', y, C.BLUE_SECTION);
    y = table(
      [
        ['Bank 1', pf(r.bank1)],
        ['Bank 2', pf(r.bank2)],
        ['Bank 3', pf(r.bank3)],
        ['Manager', pf(r.manager)],
        ['ATM', pf(r.atm)],
        ['Zelle', pf(r.zelle)],
        ['Supervisor', pf(r.supervisor)],
        ['ENDING BALANCE', pf(r.endingBalance)],
      ],
      y + 4,
      { totalLabel: 'ENDING BALANCE', amtColor: C.DARK_TEXT }
    );
    y += 20;

    // ── MANAGER LOAN TO BANK ──
    ensureSpace(120);
    y = heading('MANAGER LOAN TO BANK', y, C.BLUE_SECTION);
    const bbRows = (r.bankBoardList || []).map((trx) => {
      const lbl = trx.amount < 0 ? 'Minus' : 'Loan In';
      const dt = new Date(trx.createdDate).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      });
      return [lbl, `${trx.employeeName || ''} ${dt}`, pf(Math.abs(trx.amount))];
    });
    bbRows.push(['TOTAL', '', pf(r.bankBoardBalance)]);
    y = table(bbRows, y + 4, {
      threeCol: true,
      totalLabel: 'TOTAL',
      amtColor: C.DARK_TEXT,
      headRow: ['Type', 'Name', 'Amount'],
    });
    y += 20;

    // ── EQUATION X (Short Analysis) ──
    const { shortAnalysis } = this.props;
    const dayDataForPdf = shortAnalysis?.days?.find(
      (d) => d.day === selectedDay
    );
    if (dayDataForPdf) {
      ensureSpace(220);
      y = heading('EQUATION X — SHORT ANALYSIS', y, [99, 102, 241]);

      const pdfTotalPulls = (dayDataForPdf.employees || []).reduce(
        (s, e) => s + (Number(e.pulls) || 0),
        0
      );
      const pdfMatchDiff = Number(dayDataForPdf.matchTicketsDiff) || 0;
      const pdfMatchDiffRaw = Number(dayDataForPdf.matchTicketsDiffRaw) || 0;
      const pdfJackpotNotPay = Number(dayDataForPdf.jackpotNotPay) || 0;
      const pdfTicketOutTotal =
        (Number(dayDataForPdf.readingTotalOut) || 0) - pdfMatchDiffRaw;

      y = table(
        [
          ['Reading Total IN', pf(dayDataForPdf.readingTotalIn)],
          ['Employee Total Pulls', pf(pdfTotalPulls)],
          ['Pulls Gap', pf(dayDataForPdf.pullsGap)],
        ],
        y + 4,
        { headRow: ['Pulls Comparison', ''] }
      );
      y += 12;

      const pdfMatchRows = [
        ['Reading Out Total', pf(dayDataForPdf.readingTotalOut)],
        ['Ticket Out Total', pf(pdfTicketOutTotal)],
        [
          'Difference',
          pf(pdfJackpotNotPay !== 0 ? pdfMatchDiffRaw : pdfMatchDiff),
        ],
      ];
      if (pdfJackpotNotPay !== 0) {
        pdfMatchRows.push(['Jackpot Not Pay', pf(pdfJackpotNotPay)]);
        pdfMatchRows.push(['Real Difference', pf(pdfMatchDiff)]);
      }
      y = table(pdfMatchRows, y + 4, { headRow: ['Match Tickets', ''] });
      y += 12;

      y = table(
        (dayDataForPdf.employees || [])
          .map((e) => [e.name, pf(e.pulls), pf(e.ticketOut), pf(e.shiftShort)])
          .concat([['Total', '', '', pf(dayDataForPdf.employeeShortsTotal)]]),
        y + 4,
        {
          headRow: ['Employee', 'Pulls', 'Ticket-Out', 'Short/Over'],
          threeCol: false,
          totalLabel: 'Total',
        }
      );
      y += 12;

      y = table(
        [
          ['Pulls Gap', pf(dayDataForPdf.pullsGap)],
          ['+ Match Tickets Difference', pf(dayDataForPdf.matchTicketsDiff)],
          ['+ Employee Shorts Total', pf(dayDataForPdf.employeeShortsTotal)],
          ['= Equation X', pf(dayDataForPdf.equationX)],
          ['vs Weekly Report Short/Over', pf(dayDataForPdf.weeklyShortOver)],
          [
            'Result',
            dayDataForPdf.match
              ? 'MATCH CONFIRMED'
              : 'MISMATCH — check data entry',
          ],
        ],
        y + 4,
        { headRow: ['Equation X Proof', ''] }
      );
      y += 20;
    }

    // ── MACHINE PERCENTAGES ──
    ensureSpace(140);
    y = heading('MACHINE PERCENTAGES', y, C.PURPLE_PCT);
    const mp = r.machinePercentages || {};
    y = table(
      [
        [
          'Machine Payout (Total OUT / Total IN)',
          mp.machinePayoutPct != null ? `${mp.machinePayoutPct}%` : '0%',
        ],
        [
          'Machine Hold (Gross Profit / Total IN)',
          mp.machineHoldPct != null ? `${mp.machineHoldPct}%` : '0%',
        ],
        [
          'Gameroom Payout (Expenses / Total IN)',
          mp.gameroomPayoutPct != null ? `${mp.gameroomPayoutPct}%` : '0%',
        ],
        [
          'We Kept (Net Profit / Total IN)',
          mp.weKeptPct != null ? `${mp.weKeptPct}%` : '0%',
        ],
      ],
      y + 4,
      { amtColor: C.PURPLE_PCT }
    );
    y += 20;

    // ── EXPENSE PERCENTAGES ──
    ensureSpace(200);
    y = heading('EXPENSE PERCENTAGES', y, C.ORANGE_EXP);
    doc
      .setFont('helvetica', 'normal')
      .setFontSize(9)
      .setTextColor(...C.GRAY_TEXT);
    doc.text(`Each expense as % of Total IN (${pf(r.totalIn)})`, margin, y + 4);
    y += 12;

    const pct = r.percentages || {};
    const pctRows = [
      ['Match', pct.matchPct],
      ['High Roller Match', pct.highRollerMatchPct],
      ['Bonus', pct.bonusPct],
      ['Employees', pct.employeePct],
      ['Drawings', pct.drawingsPct],
      ["Sam's", pct.samsPct],
      ['Food Expense', pct.foodExpensePct],
      ['Maintenance/Upgrades', pct.maintenancePct],
      ['Miscellaneous', pct.miscellaneousTotal],
      ['Total Pay', pct.totalPayPct],
    ]
      .filter(([, v]) => v != null && v !== 0)
      .map(([l, v]) => [l, `${v}%`]);

    const tpIdx = pctRows.findIndex((row) => row[0] === 'Total Pay');
    if (tpIdx > -1 && tpIdx !== pctRows.length - 1) {
      const tp = pctRows.splice(tpIdx, 1)[0];
      pctRows.push(tp);
    }
    y = table(pctRows, y + 4, {
      amtColor: C.ORANGE_EXP,
      totalLabel: 'Total Pay',
    });
    y += 16;

    // ── EMPLOYEES + NOTES ──
    y = empNotes(y, r);

    Utils.handlePdfAction(
      doc.output('arraybuffer'),
      'download',
      `Full_Weekly_Report_${dayLabel}_${formatDateShort(toDate).replace(
        /[\s,]+/g,
        '_'
      )}.pdf`
    );
  };

  render() {
    const { report, allSessionIds } = this.props;
    const {
      selectedDay,
      selectedSessionIds,
      fromDate,
      toDate,
      nameInput,
      amountInput,
      type,
      showPdfViewer,
      pdfData,
      scale,
      editSummaryMode,
    } = this.state;

    const validMonday = fromDate ? this.getMondayFromTuesday(fromDate) : null;

    const hasReportData = report && Object.keys(report).length > 0;
    const selectedReport = hasReportData ? report[selectedDay] || {} : {};

    const totalExpenses = (selectedReport.expenseSet || [])
      .filter((item) => item.description !== 'Total')
      .reduce((sum, item) => sum + (item.amount || 0), 0);

    const bankBoardList = selectedReport.bankBoardList || [];
    const bankBoardBalance = selectedReport.bankBoardBalance || 0;
    const bankOpeningBalance = selectedReport.bankOpeningBalance || 0;
    const isApplyDisabled = !amountInput || !type || !nameInput;

    const { description, amount } = this.state.newExpense;
    const isSaveDisabled =
      !description.trim() || !amount.trim() || isNaN(Number(amount));

    const {
      morningPull = 0,
      nightPull = 0,
      morningCount = 0,
      nightCount = 0,
      bankList = [],
    } = selectedReport;

    const customerPayLoans = bankList.find(
      (b) => b.description?.toUpperCase() === 'CUSTOMER PAY LOANS'
    );

    const pullsEntry = bankList.find(
      (b) => b.description?.toUpperCase() === 'PULLS'
    );

    const totalPulls = (morningPull || 0) + (nightPull || 0);

    //check to disable manager summary

    const disableButton = !this.canEditReport();

    let headerButtons;

    headerButtons = [];
    if (this.state.showPdfViewer) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closePdfViewer(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.download(),
          title: 'Download PDF',
        },
        {
          icon: <PrintIcon />,
          title: 'Print PDF',
          handler: () => {
            const { pdfData } = this.state;
            if (!pdfData) return;
            Utils.handlePdfAction(pdfData, 'print', 'print.pdf');
          },
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span key="zoom-label" style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    } else if (this.state.showAuditLog) {
      headerButtons.push({
        icon: <KeyboardBackspaceIcon />,
        handler: () => this.setState({ showAuditLog: false }),
        title: 'Back',
      });
    } else {
      this.isManager() &&
        this.userHasATMRole() &&
        (this.state.isSettings
          ? headerButtons.push({
              icon: <KeyboardBackspaceIcon />,
              handler: () => this.setState({ isSettings: false }),
              title: 'Back',
            })
          : headerButtons.push({
              icon: <SettingsIcon />,
              handler: () => this.setState({ isSettings: true }),
              title: 'Manager Settings',
            }));

      if (
        !this.state.isSettings &&
        this.canViewAuditLog() &&
        this.hasAuditLogForCurrentSessions()
      ) {
        headerButtons.push({
          icon: (
            <span className="weekly-report-audit-flash-wrap">
              <span className="weekly-report-audit-flash-ring" />
              <FactCheckIcon className="weekly-report-audit-flash" />
            </span>
          ),
          handler: () => this.setState({ showAuditLog: true }),
          title: 'Audit Log — changes recorded',
        });
      }
    }

    const isDaySelected =
      selectedDay && selectedDay !== 'MANAGER' && hasReportData;

    if (isDaySelected && !this.state.showPdfViewer && !this.state.isSettings) {
      headerButtons.push({
        icon: <GetApp ref={this.pdfBtnRef} />,
        handler: this.handlePdfPopperToggle,
        title: 'Download PDF',
      });
    }

    return (
      <React.Fragment>
        {(!this.state.showAuditLog || this.state.showPdfViewer) && (
          <CustomToolbar
            title={this.state.isSettings ? 'Manager Settings' : 'Weekly Report'}
            createTitle={''}
            backTitle={''}
            headerButtons={headerButtons}
          />
        )}

        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        <Dialog
          open={this.state.showDeleteDialog}
          onClose={() => this.setState({ showDeleteDialog: false })}
        >
          <DialogTitle>Confirm</DialogTitle>
          <DialogContent style={{ marginBottom: '16px' }}>
            Are you sure you want to remove this expense?
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                width: '100px',
                marginBottom: '16px',
              }}
              onClick={() => this.setState({ showDeleteDialog: false })}
            >
              Cancel
            </Button>
            <Button
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
              color="primary"
              variant="contained"
              onClick={this.handleDeleteExpense}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.showAddExpenseDialog}
          onClose={() => this.setState({ showAddExpenseDialog: false })}
        >
          <DialogTitle>Add Expense</DialogTitle>
          <DialogContent>
            <TextField
              variant="outlined"
              style={{
                marginTop: '8px',
              }}
              InputLabelProps={{ shrink: true }}
              label="Description"
              fullWidth
              value={this.state.newExpense.description}
              onChange={(e) =>
                this.setState({
                  newExpense: {
                    ...this.state.newExpense,
                    description: e.target.value,
                  },
                })
              }
            />

            <Autocomplete
              className="expense-type"
              options={expenses}
              style={{
                marginTop: '24px',
              }}
              getOptionLabel={(option) => option || ''}
              value={this.state.newExpense.expenseType || ''}
              onChange={(event, value) => {
                this.setState({
                  newExpense: {
                    ...this.state.newExpense,
                    expenseType: value || '',
                  },
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="expenseType"
                  label="Expense Type"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />

            <TextField
              label="Amount"
              type="number"
              style={{
                marginTop: '24px',
              }}
              variant="outlined"
              inputProps={{ min: 0 }}
              InputLabelProps={{ shrink: true }}
              fullWidth
              value={this.state.newExpense.amount}
              onChange={(e) =>
                this.setState({
                  newExpense: {
                    ...this.state.newExpense,
                    amount: e.target.value,
                  },
                })
              }
            />
            <TextField
              style={{
                marginTop: '24px',
              }}
              label="Comments"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              fullWidth
              multiline
              rows={3}
              value={this.state.newExpense.comments}
              onChange={(e) =>
                this.setState({
                  newExpense: {
                    ...this.state.newExpense,
                    comments: e.target.value,
                  },
                })
              }
            />
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                width: '100px',
                marginBottom: '16px',
              }}
              onClick={() => this.setState({ showAddExpenseDialog: false })}
            >
              Cancel
            </Button>
            <Button
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
              variant="contained"
              onClick={this.handleAddExpense}
              color="primary"
              disabled={isSaveDisabled}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.isCommentDialogOpen}
          onClose={this.handleCommentCloseDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: '16px',
              padding: '16px',
            },
          }}
        >
          <DialogTitle>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Breakdown
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Typography
              variant="body1"
              sx={{ color: '#444', whiteSpace: 'pre-line' }}
            >
              {this.state.selectedComment}
            </Typography>
            {/*<Typography variant="body1" sx={{ color: '#444' }}>*/}
            {/*  {this.state.selectedComment}*/}
            {/*</Typography>*/}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleCommentCloseDialog}
              variant="contained"
              sx={{ borderRadius: '8px', textTransform: 'none' }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.isDialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="date-range-dialog"
        >
          <DialogTitle id="date-range-dialog">Filters</DialogTitle>
          <DialogContent>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div className="row-report">
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label="From Date (Tuesday only)"
                  format="yyyy-MM-dd"
                  value={fromDate}
                  onChange={this.handleFromDateChange}
                  shouldDisableDate={(date) => !this.isTuesday(date)}
                  disableMaskedInput
                />

                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label="To Date (Monday only)"
                  format="yyyy-MM-dd"
                  value={toDate}
                  onChange={this.handleToDateChange}
                  shouldDisableDate={(date) => {
                    if (!validMonday) return true;
                    return date.toDateString() !== validMonday.toDateString();
                  }}
                  disableMaskedInput
                />
              </div>
            </MuiPickersUtilsProvider>
          </DialogContent>

          <DialogActions>
            <Button
              variant="contained"
              onClick={this.handleDialogClose}
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              Cancel
            </Button>

            <Button
              autoFocus
              variant="contained"
              onClick={this.applyDateRange}
              color="primary"
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              {' '}
              Apply
            </Button>
          </DialogActions>
        </Dialog>

        {showPdfViewer ? (
          <RenderPurchaseOrderPDFPreview
            data={pdfData}
            handleSubmit={this.handleSubmit}
            creating={true}
            handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
            handlePdfLoadError={this.props.handlePdfLoadError}
            scale={scale}
          />
        ) : this.state.showAuditLog ? (
          <WeeklyReportAuditLog
            sessionIds={this.state.selectedSessionIds}
            onBack={() => this.setState({ showAuditLog: false })}
            onViewShiftReport={this.handleViewShiftReportFromAudit}
          />
        ) : this.state.isSettings ? (
          this.renderManagerSetting()
        ) : (
          <div
            style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
          >
            {/* ── Session ID selector + filter button ── */}
            <div className="dateLocationBlock">
              <IconButton
                className="filter-button"
                onClick={this.handleDialogOpen}
                size="small"
                aria-label="Filter"
              >
                <FilterIcon />
              </IconButton>

              <div style={{ flex: 1 }}>
                <Autocomplete
                  className="locationDateFieldss"
                  options={[...allSessionIds].sort(
                    (a, b) => parseInt(a) - parseInt(b)
                  )}
                  getOptionLabel={(entry) => entry || ''}
                  multiple
                  autoHighlight
                  disableClearable={false}
                  onChange={(event, value) => {
                    this.setState({ selectedSessionIds: value }, () => {
                      this.refreshComponent(this.state.selectedSessionIds);
                    });
                  }}
                  value={selectedSessionIds}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option}
                        variant="outlined"
                        label={option}
                        {...getTagProps({ index })}
                        color="primary"
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Reading Session IDs"
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      name="sessionSelect"
                    />
                  )}
                />
              </div>
            </div>

            <div ref={this.dayRowRef}>{this.dateSelectRow()}</div>

            {selectedDay === 'MANAGER'
              ? this.renderManagerTable()
              : selectedDay === 'SUMMARY'
              ? this.renderSummaryTable()
              : hasReportData && (
                  <div className="report-container">
                    <Button
                      variant="outlined"
                      style={{ marginBottom: '16px' }}
                      startIcon={
                        this.state.editSummaryMode ? (
                          <VisibilityIcon />
                        ) : (
                          <EditIcon />
                        )
                      }
                      onClick={() =>
                        this.setState({
                          editSummaryMode: !this.state.editSummaryMode,
                        })
                      }
                      sx={{ mb: 2 }}
                      disabled={disableButton}
                    >
                      {this.state.editSummaryMode
                        ? 'View Summary'
                        : 'Edit Summary'}
                    </Button>
                    <div className="grid-slider" ref={this.reportContainerRef}>
                      {/* ════════════════════════════════════════
                              1. PROFIT GRID
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'profit' && (
                        <div className="grid-section">
                          <h4 className="title-heading">
                            <span role="img" aria-label="cash">
                              💵
                            </span>{' '}
                            Cash Flow
                          </h4>

                          {/* Money In */}
                          <div className="profit-section">
                            <div className="profit-section-header">
                              <span className="profit-section-dot profit-section-dot--in" />
                              <span className="profit-section-title">
                                <span role="img" aria-label="money in">
                                  ⬇️
                                </span>{' '}
                                Money In
                              </span>
                            </div>

                            {[
                              {
                                label: 'Opening Balance',
                                field: 'openingBalance',
                                editable: true,
                                requiresWeekStart: true,
                                hideIfNotWeekStart: false,
                              },
                              {
                                label: 'Reading Total IN',
                                field: 'totalIn',
                                editable: false,
                                requiresWeekStart: false,
                              },
                              {
                                label: 'Employee Short Payment',
                                field: 'employeeShortPay',
                                editable: true,
                                requiresWeekStart: false,
                              },
                              {
                                label: 'Loan In',
                                field: 'loanIn',
                                editable: true,
                                requiresWeekStart: false,
                              },
                              {
                                label: 'Add Bank',
                                field: 'addBank',
                                editable: false,
                                requiresWeekStart: false,
                              },
                            ].map(
                              ({
                                label,
                                field,
                                editable,
                                requiresWeekStart,
                                hideIfNotWeekStart,
                              }) => {
                                if (
                                  hideIfNotWeekStart &&
                                  !selectedReport.weekStart
                                )
                                  return null;
                                let value = selectedReport[field] || 0;
                                if (field === 'totalIn') {
                                  value =
                                    (selectedReport.totalIn || 0) +
                                    (selectedReport.jpOtherIn || 0);
                                }

                                // Hide zero-value rows in preview mode
                                if (!editSummaryMode && value === 0)
                                  return null;

                                const canEdit =
                                  editable &&
                                  (!requiresWeekStart ||
                                    selectedReport.weekStart);

                                const hasLoanInBreakdown =
                                  field === 'loanIn' &&
                                  !!customerPayLoans?.comments;

                                return (
                                  <div key={field}>
                                    {!this.state.editingFields[field] ? (
                                      <div className="profit-row">
                                        <span className="profit-row-label">
                                          {label}
                                        </span>
                                        <div className="profit-row-value">
                                          <span>${value.toLocaleString()}</span>
                                          {hasLoanInBreakdown && (
                                            <Tooltip title="View Breakdown">
                                              <IconButton
                                                size="small"
                                                style={{
                                                  marginLeft: '2px',
                                                  padding: '2px',
                                                }}
                                                onClick={() =>
                                                  this.handleCommentOpenDialog(
                                                    customerPayLoans.comments
                                                  )
                                                }
                                              >
                                                <DescriptionIcon fontSize="small" />
                                              </IconButton>
                                            </Tooltip>
                                          )}
                                          {canEdit && editSummaryMode && (
                                            <IconButton
                                              size="small"
                                              style={{
                                                marginLeft: '2px',
                                                padding: '2px',
                                              }}
                                              onClick={() =>
                                                this.handleEditClick(
                                                  field,
                                                  selectedReport[field] || 0
                                                )
                                              }
                                            >
                                              <EditIcon
                                                style={{
                                                  fontSize: '14px',
                                                  color: '#aaa',
                                                }}
                                              />
                                            </IconButton>
                                          )}
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="profit-edit-row">
                                        <div className="profit-edit-row-label">
                                          {label}
                                        </div>
                                        <div className="profit-edit-controls">
                                          <input
                                            type="number"
                                            className="profit-edit-input"
                                            value={
                                              this.state.fieldValues[field]
                                            }
                                            onChange={(e) =>
                                              this.handleFieldChange(field, e)
                                            }
                                          />
                                          <button
                                            className="profit-apply-btn"
                                            onClick={() =>
                                              this.handleApplyClick(field)
                                            }
                                          >
                                            Apply
                                          </button>
                                          <IconButton
                                            size="small"
                                            className="profit-close-btn"
                                            onClick={() =>
                                              this.setState((prev) => ({
                                                editingFields: {
                                                  ...prev.editingFields,
                                                  [field]: false,
                                                },
                                              }))
                                            }
                                          >
                                            <CloseIcon
                                              style={{ fontSize: '16px' }}
                                            />
                                          </IconButton>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              }
                            )}

                            {/* Total IN */}
                            {(() => {
                              const computedTotalIn =
                                (selectedReport.openingBalance || 0) +
                                (selectedReport.totalIn || 0) +
                                (selectedReport.jpOtherIn || 0) +
                                (selectedReport.employeeShortPay || 0) +
                                (selectedReport.loanIn || 0) +
                                (selectedReport.addBank || 0);
                              return (
                                <div className="profit-total-row profit-total-row--in">
                                  <span className="profit-total-label profit-total-label--in">
                                    Total IN
                                  </span>
                                  <span className="profit-total-value profit-total-value--in">
                                    ${computedTotalIn.toLocaleString()}
                                  </span>
                                </div>
                              );
                            })()}
                          </div>

                          {/* Money Out */}
                          <div className="profit-section">
                            <div className="profit-section-header">
                              <span className="profit-section-dot profit-section-dot--out" />
                              <span className="profit-section-title">
                                <span role="img" aria-label="money out">
                                  ⬆️
                                </span>{' '}
                                Money Out
                              </span>
                            </div>

                            {[
                              {
                                label: 'Reading Total OUT',
                                field: 'totalOut',
                                editable: false,
                              },
                              {
                                label: 'Minus Bank',
                                field: 'minusBank',
                                editable: false,
                              },
                            ].map(({ label, field }) => {
                              let value = selectedReport[field] || 0;
                              if (field === 'totalOut') {
                                value =
                                  (selectedReport.totalOut || 0) +
                                  (selectedReport.jpOtherOut || 0) -
                                  (selectedReport.jackpotNotPay || 0);
                              }
                              if (!editSummaryMode && value === 0) return null;
                              return (
                                <div key={field} className="profit-row">
                                  <span className="profit-row-label">
                                    {label}
                                  </span>
                                  <span className="profit-row-value">
                                    ${value.toLocaleString()}
                                  </span>
                                </div>
                              );
                            })}

                            {(editSummaryMode || totalExpenses !== 0) && (
                              <div className="profit-row">
                                <span className="profit-row-label">
                                  All Expenses
                                </span>
                                <span className="profit-row-value">
                                  ${(totalExpenses || 0).toLocaleString()}
                                </span>
                              </div>
                            )}

                            {/* Total OUT */}
                            {(() => {
                              const computedReadingOut =
                                (selectedReport.totalOut || 0) +
                                (selectedReport.jpOtherOut || 0) -
                                (selectedReport.jackpotNotPay || 0);
                              const computedTotalOut =
                                computedReadingOut +
                                (selectedReport.minusBank || 0) +
                                (totalExpenses || 0);
                              return (
                                <div className="profit-total-row profit-total-row--out">
                                  <span className="profit-total-label profit-total-label--out">
                                    Total OUT
                                  </span>
                                  <span className="profit-total-value profit-total-value--out">
                                    ${computedTotalOut.toLocaleString()}
                                  </span>
                                </div>
                              );
                            })()}
                          </div>

                          {/* Difference */}
                          {(() => {
                            const computedTotalIn =
                              (selectedReport.openingBalance || 0) +
                              (selectedReport.totalIn || 0) +
                              (selectedReport.jpOtherIn || 0) +
                              (selectedReport.employeeShortPay || 0) +
                              (selectedReport.loanIn || 0) +
                              (selectedReport.addBank || 0);
                            const computedReadingOut =
                              (selectedReport.totalOut || 0) +
                              (selectedReport.jpOtherOut || 0) -
                              (selectedReport.jackpotNotPay || 0);
                            const computedTotalOut =
                              computedReadingOut +
                              (selectedReport.minusBank || 0) +
                              (totalExpenses || 0);
                            const difference =
                              computedTotalIn - computedTotalOut;
                            return (
                              <div className="profit-difference">
                                <span className="profit-difference-label">
                                  Difference
                                </span>
                                <span
                                  className="profit-difference-value"
                                  style={{
                                    color:
                                      difference < 0 ? '#ef4444' : '#16a34a',
                                  }}
                                >
                                  {difference < 0
                                    ? `($${Math.abs(
                                        difference
                                      ).toLocaleString()})`
                                    : `$${difference.toLocaleString()}`}
                                </span>
                              </div>
                            );
                          })()}

                          {/* Ending Balance */}
                          <div className="profit-ending-balance">
                            <span className="profit-ending-balance-label">
                              Ending Balance
                            </span>
                            <span className="profit-ending-balance-value">
                              $
                              {selectedReport.endingBalance?.toLocaleString() ||
                                '0'}
                            </span>
                          </div>

                          {/* Short / Over */}
                          <div className="profit-short-over">
                            <span className="profit-short-over-label">
                              Short / Over
                            </span>
                            <span
                              className={`profit-short-over-value ${
                                selectedReport.shortOver < 0
                                  ? 'profit-short-over-value--negative'
                                  : 'profit-short-over-value--positive'
                              }`}
                            >
                              {selectedReport.shortOver < 0
                                ? `-$${Math.abs(
                                    selectedReport.shortOver
                                  ).toLocaleString()}`
                                : `$${
                                    selectedReport.shortOver?.toLocaleString() ||
                                    '0'
                                  }`}
                            </span>
                          </div>

                          {/* Net Profit + Customers */}
                          <div className="profit-summary-grid">
                            <div
                              className={`profit-net-card ${
                                selectedReport.netProfit < 0
                                  ? 'negative'
                                  : 'positive'
                              }`}
                            >
                              <div className="profit-net-card-label">
                                Net Profit
                              </div>
                              <div className="profit-net-card-value">
                                {selectedReport.netProfit < 0
                                  ? `-$${Math.abs(
                                      selectedReport.netProfit
                                    ).toLocaleString()}`
                                  : `$${
                                      selectedReport.netProfit?.toLocaleString() ||
                                      '0'
                                    }`}
                              </div>
                            </div>
                            <div className="profit-customers-card">
                              <div className="profit-customers-card-label">
                                Customers
                              </div>
                              <div className="profit-customers-card-value">
                                {selectedReport?.customers?.length || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              2. EXPENSES GRID
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'expenses' && (
                        <div className="grid-section">
                          <h4 className="title-heading">
                            <span role="img" aria-label="expenses">
                              📋
                            </span>{' '}
                            Expenses
                          </h4>
                          <div className="grid">
                            {selectedReport.expenseSet &&
                            selectedReport.expenseSet.length > 0 ? (
                              selectedReport.expenseSet.map(
                                (expense, index) => {
                                  const isTotal =
                                    expense.description?.toLowerCase() ===
                                    'total';

                                  if (isTotal) {
                                    return (
                                      <React.Fragment key={index}>
                                        {/* Add Expense button — edit mode only */}
                                        {editSummaryMode && (
                                          <div className="item">
                                            <Tooltip
                                              title="Add Expense"
                                              style={{
                                                width: '36px',
                                                height: '36px',
                                              }}
                                            >
                                              <IconButton
                                                onClick={() =>
                                                  this.setState({
                                                    showAddExpenseDialog: true,
                                                  })
                                                }
                                              >
                                                <AddCircleIcon
                                                  fontSize="small"
                                                  color="secondary"
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          </div>
                                        )}
                                        <div
                                          className="item"
                                          style={{ backgroundColor: '#e0f5e9' }}
                                        >
                                          <span>{expense.description}</span>
                                          <div
                                            style={{
                                              color: 'black',
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            $
                                            {expense.amount?.toLocaleString() ||
                                              0}
                                          </div>
                                        </div>
                                      </React.Fragment>
                                    );
                                  }

                                  // In preview mode, hide expenses with amount 0
                                  if (
                                    !editSummaryMode &&
                                    (expense.amount === 0 ||
                                      expense.amount == null)
                                  )
                                    return null;

                                  return (
                                    <div
                                      key={index}
                                      className="item"
                                      style={{
                                        backgroundColor: expense.isManager
                                          ? '#ffe5b4'
                                          : 'transparent',
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '6px',
                                        }}
                                      >
                                        {expense.description}
                                        {expense.comments && (
                                          <Tooltip title="View Comment">
                                            <IconButton
                                              size="small"
                                              onClick={() =>
                                                this.handleCommentOpenDialog(
                                                  expense.comments
                                                )
                                              }
                                            >
                                              <DescriptionIcon fontSize="small" />
                                            </IconButton>
                                          </Tooltip>
                                        )}
                                      </span>
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          width: '100%',
                                          alignItems: 'center',
                                        }}
                                      >
                                        ${expense.amount?.toLocaleString() || 0}
                                        {/* Delete button — edit mode only */}
                                        {expense.isManager &&
                                          editSummaryMode && (
                                            <IconButton
                                              style={{
                                                width: '36px',
                                                height: '36px',
                                              }}
                                              onClick={() =>
                                                this.setState({
                                                  showDeleteDialog: true,
                                                  rowToDelete: index,
                                                })
                                              }
                                            >
                                              <RemoveCircleIcon
                                                fontSize="small"
                                                color="error"
                                              />
                                            </IconButton>
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                              )
                            ) : (
                              <div className="item">No expenses recorded.</div>
                            )}
                          </div>
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              3. READINGS GRID
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'readings' && (
                        <div className="grid-section">
                          <h4 className="title-heading">
                            <span role="img" aria-label="readings">
                              🎰
                            </span>{' '}
                            Readings
                          </h4>
                          <div className="grid">
                            {(editSummaryMode ||
                              (selectedReport.totalIn || 0) !== 0) && (
                              <div className="item">
                                <span>Total IN</span>$
                                {selectedReport.totalIn?.toLocaleString() || 0}
                              </div>
                            )}

                            {(editSummaryMode ||
                              (selectedReport.totalOut || 0) !== 0) && (
                              <div className="item">
                                <span>Total OUT</span>$
                                {selectedReport.totalOut?.toLocaleString() || 0}
                              </div>
                            )}

                            {/* Jackpot Not Pay */}
                            {(editSummaryMode ||
                              (selectedReport.jackpotNotPay || 0) !== 0) && (
                              <div className="item">
                                <span>Jackpot Not Pay</span> $
                                {this.state.editingFields.jackpotNotPay ? (
                                  <>
                                    <input
                                      type="number"
                                      value={
                                        this.state.fieldValues.jackpotNotPay
                                      }
                                      onChange={(e) =>
                                        this.handleFieldChange(
                                          'jackpotNotPay',
                                          e
                                        )
                                      }
                                      style={{
                                        marginLeft: '8px',
                                        width: '120px',
                                        padding: '6px 8px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                      }}
                                    />
                                    <button
                                      onClick={() =>
                                        this.handleApplyClick('jackpotNotPay')
                                      }
                                      className="profit-apply-btn"
                                      style={{ marginLeft: '8px' }}
                                    >
                                      Apply
                                    </button>
                                    <IconButton
                                      size="small"
                                      style={{ marginLeft: '6px' }}
                                      onClick={() =>
                                        this.setState((prev) => ({
                                          editingFields: {
                                            ...prev.editingFields,
                                            jackpotNotPay: false,
                                          },
                                        }))
                                      }
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </>
                                ) : (
                                  <>
                                    {selectedReport.jackpotNotPay?.toLocaleString() ||
                                      0}
                                    {editSummaryMode && (
                                      <IconButton
                                        size="small"
                                        style={{ marginLeft: '6px' }}
                                        onClick={() =>
                                          this.handleEditClick(
                                            'jackpotNotPay',
                                            selectedReport.jackpotNotPay || 0
                                          )
                                        }
                                      >
                                        <EditIcon
                                          style={{
                                            fontSize: '14px',
                                            color: '#aaa',
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </>
                                )}
                              </div>
                            )}

                            {/* Other In */}
                            {(editSummaryMode ||
                              (selectedReport.jpOtherIn || 0) !== 0) && (
                              <div className="item">
                                <span>Other In</span> $
                                {this.state.editingFields.jpOtherIn ? (
                                  <>
                                    <input
                                      type="number"
                                      value={this.state.fieldValues.jpOtherIn}
                                      onChange={(e) =>
                                        this.handleFieldChange('jpOtherIn', e)
                                      }
                                      style={{
                                        marginLeft: '8px',
                                        width: '120px',
                                        padding: '6px 8px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                      }}
                                    />
                                    <button
                                      onClick={() =>
                                        this.handleApplyClick('jpOtherIn')
                                      }
                                      className="profit-apply-btn"
                                      style={{ marginLeft: '8px' }}
                                    >
                                      Apply
                                    </button>
                                    <IconButton
                                      size="small"
                                      style={{ marginLeft: '6px' }}
                                      onClick={() =>
                                        this.setState((prev) => ({
                                          editingFields: {
                                            ...prev.editingFields,
                                            jpOtherIn: false,
                                          },
                                        }))
                                      }
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </>
                                ) : (
                                  <>
                                    {selectedReport.jpOtherIn?.toLocaleString() ||
                                      0}
                                    {editSummaryMode && (
                                      <IconButton
                                        size="small"
                                        style={{ marginLeft: '6px' }}
                                        onClick={() =>
                                          this.handleEditClick(
                                            'jpOtherIn',
                                            selectedReport.jpOtherIn || 0
                                          )
                                        }
                                      >
                                        <EditIcon
                                          style={{
                                            fontSize: '14px',
                                            color: '#aaa',
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </>
                                )}
                              </div>
                            )}

                            {/* Other Out */}
                            {(editSummaryMode ||
                              (selectedReport.jpOtherOut || 0) !== 0) && (
                              <div className="item">
                                <span>Other Out</span> $
                                {this.state.editingFields.jpOtherOut ? (
                                  <>
                                    <input
                                      type="number"
                                      value={this.state.fieldValues.jpOtherOut}
                                      onChange={(e) =>
                                        this.handleFieldChange('jpOtherOut', e)
                                      }
                                      style={{
                                        marginLeft: '8px',
                                        width: '120px',
                                        padding: '6px 8px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                      }}
                                    />
                                    <button
                                      onClick={() =>
                                        this.handleApplyClick('jpOtherOut')
                                      }
                                      className="profit-apply-btn"
                                      style={{ marginLeft: '8px' }}
                                    >
                                      Apply
                                    </button>
                                    <IconButton
                                      size="small"
                                      style={{ marginLeft: '6px' }}
                                      onClick={() =>
                                        this.setState((prev) => ({
                                          editingFields: {
                                            ...prev.editingFields,
                                            jpOtherOut: false,
                                          },
                                        }))
                                      }
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </>
                                ) : (
                                  <>
                                    {selectedReport.jpOtherOut?.toLocaleString() ||
                                      0}
                                    {editSummaryMode && (
                                      <IconButton
                                        size="small"
                                        style={{ marginLeft: '6px' }}
                                        onClick={() =>
                                          this.handleEditClick(
                                            'jpOtherOut',
                                            selectedReport.jpOtherOut || 0
                                          )
                                        }
                                      >
                                        <EditIcon
                                          style={{
                                            fontSize: '14px',
                                            color: '#aaa',
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </>
                                )}
                              </div>
                            )}

                            {/* Adjusted divider */}
                            <div
                              className="readings-divider"
                              style={{ marginBottom: '8px' }}
                            >
                              <span className="readings-divider-label">
                                Adjusted
                              </span>
                            </div>

                            {/* Real Total In */}
                            <div className="readings-row readings-row--adjusted">
                              <span className="readings-label">
                                <strong>Real Total In</strong>
                              </span>
                              <span className="readings-value readings-value--green">
                                <strong>
                                  $
                                  {(
                                    (selectedReport.totalIn || 0) +
                                    (selectedReport.jpOtherIn || 0)
                                  ).toLocaleString()}
                                </strong>
                              </span>
                            </div>

                            {/* Real Total Out */}
                            <div className="readings-row readings-row--adjusted">
                              <span className="readings-label">
                                <strong>Real Total Out</strong>
                              </span>
                              <span className="readings-value readings-value--red">
                                <strong>
                                  $
                                  {(
                                    (selectedReport.totalOut || 0) +
                                    (selectedReport.jpOtherOut || 0) -
                                    (selectedReport.jackpotNotPay || 0)
                                  ).toLocaleString()}
                                </strong>
                              </span>
                            </div>

                            {/* Gross Profit */}
                            <div className="readings-row readings-row--adjusted item lightGreen">
                              <span>
                                <strong>Gross Profit</strong>
                              </span>
                              <span
                                className={`readings-value ${
                                  selectedReport.grossProfit < 0
                                    ? 'readings-value--red'
                                    : 'readings-value--green'
                                }`}
                              >
                                <strong>
                                  {selectedReport.grossProfit < 0
                                    ? `($${Math.abs(
                                        selectedReport.grossProfit
                                      ).toLocaleString()})`
                                    : `$${
                                        selectedReport.grossProfit?.toLocaleString() ||
                                        0
                                      }`}
                                </strong>
                              </span>
                            </div>

                            {/* Employees Shift */}
                            <div className="item" style={{ marginTop: '16px' }}>
                              <span style={{ marginBottom: '16px' }}>
                                <strong>
                                  <span role="img" aria-label="employees">
                                    👥
                                  </span>{' '}
                                  Employees Shift
                                </strong>
                              </span>
                              {selectedReport.employeeDetails?.length > 0 ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    alignItems: 'flex-start',
                                    padding: 0,
                                    margin: 0,
                                  }}
                                >
                                  {selectedReport.employeeDetails.map(
                                    (employee, index) => (
                                      <Chip
                                        key={`${employee.userId}-${employee.sessionId}-${employee.date}-${index}`}
                                        label={`${employee.name} - ${employee.date} ${employee.timeIn}`}
                                        clickable
                                        onClick={() => {
                                          const data = {
                                            userId: employee.userId,
                                            locationId: employee.locationId,
                                            date: employee.date,
                                            clockId: employee.clockId,
                                          };
                                          this.props.getGlobalPDFPreview(
                                            data,
                                            this.showPdfErrorMessage,
                                            'previewShiftReport'
                                          );
                                          const rc =
                                            document.querySelector(
                                              '.report-container'
                                            );
                                          this.setState({
                                            showPdfViewer: true,
                                            savedScrollY: rc ? rc.scrollTop : 0,
                                          });
                                        }}
                                      />
                                    )
                                  )}
                                </div>
                              ) : (
                                <span>No employees</span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              4. CLOSING BALANCE GRID
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'closingBalance' && (
                        <div className="grid-section">
                          <h4 className="title-heading">
                            <span role="img" aria-label="bank">
                              🏦
                            </span>{' '}
                            Closing Balance
                          </h4>
                          <div className="grid">
                            {/* Reusable editable field renderer */}
                            {[
                              { label: '🏦 Bank 1', field: 'bank1' },
                              { label: '🏦 Bank 2', field: 'bank2' },
                              { label: '🏦 Bank 3', field: 'bank3' },
                              { label: '👤 Manager', field: 'manager' },
                              { label: '🏧 ATM', field: 'atm' },
                              { label: '📱 Zelle', field: 'zelle' },
                              { label: '👤 Supervisor', field: 'supervisor' },
                            ].map(({ label, field }) => {
                              const value = selectedReport[field] || 0;
                              if (!editSummaryMode && value === 0) return null;
                              return (
                                <div key={field} className="item">
                                  <span>{label}</span> $
                                  {this.state.editingFields[field] ? (
                                    <>
                                      <input
                                        type="number"
                                        value={this.state.fieldValues[field]}
                                        onChange={(e) =>
                                          this.handleFieldChange(field, e)
                                        }
                                        style={{
                                          marginLeft: '8px',
                                          width: '120px',
                                          padding: '6px 8px',
                                          border: '1px solid #ccc',
                                          borderRadius: '4px',
                                        }}
                                      />
                                      <button
                                        onClick={() =>
                                          this.handleApplyClick(field)
                                        }
                                        className="profit-apply-btn"
                                        style={{ marginLeft: '8px' }}
                                      >
                                        Apply
                                      </button>
                                      <IconButton
                                        size="small"
                                        style={{ marginLeft: '6px' }}
                                        onClick={() =>
                                          this.setState((prev) => ({
                                            editingFields: {
                                              ...prev.editingFields,
                                              [field]: false,
                                            },
                                          }))
                                        }
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </>
                                  ) : (
                                    <>
                                      {value.toLocaleString()}
                                      {editSummaryMode && (
                                        <IconButton
                                          size="small"
                                          style={{ marginLeft: '6px' }}
                                          onClick={() =>
                                            this.handleEditClick(field, value)
                                          }
                                        >
                                          <EditIcon
                                            style={{
                                              fontSize: '14px',
                                              color: '#aaa',
                                            }}
                                          />
                                        </IconButton>
                                      )}
                                    </>
                                  )}
                                </div>
                              );
                            })}

                            {/* Subtotal — always show */}
                            <div className="item">
                              <span>Subtotal</span>$
                              {selectedReport.bankSubtotal?.toLocaleString() ||
                                0}
                            </div>

                            {/* Minus Rollover */}
                            {(editSummaryMode ||
                              (selectedReport.minusRollover || 0) !== 0) && (
                              <div className="item">
                                <span>Minus Rollover</span> $
                                {this.state.editingFields.minusRollover ? (
                                  <>
                                    <input
                                      type="number"
                                      value={
                                        this.state.fieldValues.minusRollover
                                      }
                                      onChange={(e) =>
                                        this.handleFieldChange(
                                          'minusRollover',
                                          e
                                        )
                                      }
                                      style={{
                                        marginLeft: '8px',
                                        width: '120px',
                                        padding: '6px 8px',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                      }}
                                    />
                                    <button
                                      onClick={() =>
                                        this.handleApplyClick('minusRollover')
                                      }
                                      className="profit-apply-btn"
                                      style={{ marginLeft: '8px' }}
                                    >
                                      Apply
                                    </button>
                                    <IconButton
                                      size="small"
                                      style={{ marginLeft: '6px' }}
                                      onClick={() =>
                                        this.setState((prev) => ({
                                          editingFields: {
                                            ...prev.editingFields,
                                            minusRollover: false,
                                          },
                                        }))
                                      }
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </>
                                ) : (
                                  <>
                                    {selectedReport.minusRollover?.toLocaleString() ||
                                      0}
                                    {editSummaryMode && (
                                      <IconButton
                                        size="small"
                                        style={{ marginLeft: '6px' }}
                                        onClick={() =>
                                          this.handleEditClick(
                                            'minusRollover',
                                            selectedReport.minusRollover || 0
                                          )
                                        }
                                      >
                                        <EditIcon
                                          style={{
                                            fontSize: '14px',
                                            color: '#aaa',
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </>
                                )}
                              </div>
                            )}

                            {/* E/B Total — always show */}
                            <div className="item">
                              <span>E/B Total</span>$
                              {selectedReport.ebTotal?.toLocaleString() || 0}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              5. MANAGER LOAN TO BANK
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'managerLoan' && (
                        <div className="grid-section bank-board-section">
                          <h4
                            className="title-heading"
                            style={{
                              marginBottom: '15px',
                              fontSize: '18px',
                              fontWeight: '600',
                            }}
                          >
                            <span role="img" aria-label="bank board">
                              📒
                            </span>{' '}
                            Manager Loan To Bank
                          </h4>

                          <div
                            style={{
                              margin: '0 auto',
                              fontFamily: 'Arial, sans-serif',
                              border: '1px solid #e5e7eb',
                              borderRadius: '12px',
                              padding: '20px',
                              boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                              background: '#fff',
                            }}
                          >
                            {/* Input row — edit mode only */}
                            {editSummaryMode && (
                              <div
                                className="bank-board-fields"
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: '10px',
                                  marginBottom: '20px',
                                  alignItems: 'center',
                                }}
                              >
                                <select
                                  value={type}
                                  onChange={this.handleTypeChange}
                                  style={{
                                    height: '39px',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                    flex: '1 1 100px',
                                    minWidth: '100px',
                                    background: '#f9fafb',
                                  }}
                                >
                                  <option value="">Type</option>
                                  <option value="add">Add</option>
                                  <option value="minus">Minus</option>
                                </select>
                                <input
                                  type="text"
                                  value={nameInput}
                                  onChange={this.handleNameChange}
                                  placeholder="Name"
                                  style={{
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                    flex: '1 1 120px',
                                    minWidth: '120px',
                                    background: '#f9fafb',
                                  }}
                                />
                                <input
                                  type="text"
                                  value={amountInput}
                                  onChange={this.handleAmountChange}
                                  placeholder="Amount"
                                  style={{
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                    flex: '1 1 100px',
                                    minWidth: '100px',
                                    background: '#f9fafb',
                                  }}
                                />
                                <button
                                  onClick={this.handleApply}
                                  disabled={isApplyDisabled}
                                  className="profit-apply-btn"
                                  style={{
                                    marginLeft: '0px',
                                    flex: '1 1 80px',
                                    minWidth: '80px',
                                  }}
                                >
                                  Apply
                                </button>
                              </div>
                            )}

                            {/* Transactions */}
                            <div style={{ marginBottom: '15px' }}>
                              <div
                                className="item lightgreen"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  borderBottom: '1px solid #f1f5f9',
                                  borderRadius: '6px',
                                }}
                              >
                                <span style={{ marginTop: '4px' }}>
                                  Opening Balance:
                                </span>
                                <span
                                  style={{
                                    marginTop: '4px',
                                    marginLeft: '8px',
                                    color:
                                      bankOpeningBalance < 0
                                        ? '#dc2626'
                                        : '#16a34a',
                                    fontWeight: '600',
                                  }}
                                >
                                  {bankOpeningBalance < 0 ? '-' : '+'} $
                                  {Math.abs(bankOpeningBalance)}
                                </span>
                              </div>

                              {bankBoardList.map((trx, idx) => (
                                <div
                                  key={idx}
                                  style={{
                                    marginTop: '8px',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '4px 12px',
                                    alignItems: 'center',
                                    padding: '10px 8px',
                                    borderBottom: '1px solid #f1f5f9',
                                    backgroundColor:
                                      idx % 2 === 0 ? '#fafafa' : '#fff',
                                    borderRadius: '6px',
                                  }}
                                >
                                  <span
                                    style={{
                                      color:
                                        trx.amount < 0 ? '#dc2626' : '#16a34a',
                                      fontWeight: '600',
                                      minWidth: '80px',
                                    }}
                                  >
                                    {trx.amount < 0 ? '-' : '+'} $
                                    {Math.abs(trx.amount)}
                                  </span>
                                  <span
                                    style={{
                                      color: '#4b5563',
                                      fontSize: '14px',
                                    }}
                                  >
                                    {new Date(
                                      trx.createdDate
                                    ).toLocaleDateString()}
                                  </span>
                                  <span
                                    style={{
                                      color: '#374151',
                                      fontWeight: '500',
                                      fontSize: '14px',
                                      fontStyle: 'italic',
                                      marginLeft: 'auto',
                                      textAlign: 'right',
                                    }}
                                  >
                                    — {trx.employeeName} ({trx.userName})
                                  </span>
                                </div>
                              ))}
                            </div>

                            {/* Balance */}
                            <div
                              style={{
                                textAlign: 'right',
                                fontWeight: 'bold',
                                fontSize: '18px',
                                color: '#111827',
                                padding: '10px',
                                borderRadius: '8px',
                                background: '#f9fafb',
                                boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
                              }}
                            >
                              Balance: ${bankBoardBalance.toFixed(2)}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              6. EXPENSES + MACHINE PERCENTAGES (one tab)
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'percentages' && (
                        <div className="grid-section">
                          <h4 className="title-heading">
                            <span role="img" aria-label="chart">
                              📊
                            </span>{' '}
                            Expense %
                          </h4>
                          <div className="grid">
                            {[
                              { label: 'Match', field: 'matchPct' },
                              {
                                label: 'High Roller Match',
                                field: 'highRollerMatchPct',
                              },
                              { label: 'Bonus', field: 'bonusPct' },
                              { label: 'Employees', field: 'employeePct' },
                              { label: 'Drawings', field: 'drawingsPct' },
                              { label: "Sam's", field: 'samsPct' },
                              {
                                label: 'Food Expense',
                                field: 'foodExpensePct',
                              },
                              {
                                label: 'Maintenance/Upgrades',
                                field: 'maintenancePct',
                              },
                              {
                                label: 'Miscellaneous',
                                field: 'miscellaneousTotal',
                              },
                              { label: 'Total Pay', field: 'totalPayPct' },
                            ].map(({ label, field }) => {
                              const pct = selectedReport.percentages?.[field];
                              if (
                                !editSummaryMode &&
                                (pct === 0 || pct == null)
                              )
                                return null;
                              return (
                                <div key={field} className="item blue">
                                  <span>{label}</span>
                                  <strong>
                                    {pct != null ? `${pct}%` : '0%'}
                                  </strong>
                                </div>
                              );
                            })}
                          </div>

                          <h4
                            className="title-heading"
                            style={{ marginTop: '16px' }}
                          >
                            <span role="img" aria-label="machine">
                              ⚙️
                            </span>{' '}
                            Machine %
                          </h4>
                          <div className="grid">
                            {[
                              {
                                label: 'Machine Payout',
                                field: 'machinePayoutPct',
                              },
                              {
                                label: 'Machine Hold',
                                field: 'machineHoldPct',
                              },
                              {
                                label: 'Gameroom Payout',
                                field: 'gameroomPayoutPct',
                              },
                              { label: 'We Kept', field: 'weKeptPct' },
                            ].map(({ label, field }) => {
                              const pct =
                                selectedReport.machinePercentages?.[field];
                              if (
                                !editSummaryMode &&
                                (pct === 0 || pct == null)
                              )
                                return null;
                              return (
                                <div key={field} className="item orange">
                                  <span>{label}</span>
                                  <strong
                                    style={{
                                      color: pct < 0 ? 'red' : 'inherit',
                                    }}
                                  >
                                    {pct != null
                                      ? pct < 0
                                        ? `(${Math.abs(pct)}%)`
                                        : `${pct}%`
                                      : '0%'}
                                  </strong>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {/* ════════════════════════════════════════
                              9. SHORT ANALYSIS (Equation X)
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'shortAnalysis' &&
                        this.renderShortAnalysis()}

                      {/* ════════════════════════════════════════
                              8. DAILY ACTIVITY SUMMARY (own tab)
                          ════════════════════════════════════════ */}
                      {this.state.selectedTab === 'dailyActivity' && (
                        <div className="grid-section">
                          <h4 className="title-heading">
                            <span role="img" aria-label="notes">
                              📝
                            </span>{' '}
                            Daily Activity Summary
                          </h4>
                          <div className="grid">
                            <div className="das-card">
                              {/* Customer Pay Loans */}
                              {(editSummaryMode ||
                                (customerPayLoans?.amount || 0) !== 0) && (
                                <div className="das-row das-row--peach">
                                  <div className="das-row-left">
                                    <span
                                      className="das-icon"
                                      role="img"
                                      aria-label="document"
                                    >
                                      📄
                                    </span>
                                    <div>
                                      <div className="das-label">
                                        Customer Pay Loans
                                      </div>
                                      <div className="das-amount">
                                        {customerPayLoans
                                          ? this.fmt(customerPayLoans.amount)
                                          : '$0'}
                                      </div>
                                    </div>
                                  </div>
                                  {customerPayLoans?.comments && (
                                    <button
                                      className="das-icon-btn"
                                      title={customerPayLoans.comments}
                                      onClick={() =>
                                        this.handleCommentOpenDialog(
                                          customerPayLoans.comments
                                        )
                                      }
                                    >
                                      <DescriptionIcon />
                                    </button>
                                  )}
                                </div>
                              )}

                              {/* Employee Pulls Total */}
                              {(editSummaryMode || totalPulls !== 0) && (
                                <div className="das-row das-row--blue">
                                  <div className="das-row-left">
                                    <span
                                      className="das-icon"
                                      role="img"
                                      aria-label="coins"
                                    >
                                      🪙
                                    </span>
                                    <div>
                                      <div className="das-label">
                                        Employee Pulls (Total)
                                      </div>
                                      <div className="das-amount">
                                        {this.fmt(totalPulls)}
                                      </div>
                                    </div>
                                  </div>
                                  {pullsEntry?.comments && (
                                    <button
                                      className="das-icon-btn"
                                      title={pullsEntry.comments}
                                      onClick={() =>
                                        this.handleCommentOpenDialog(
                                          pullsEntry.comments
                                        )
                                      }
                                    >
                                      <DescriptionIcon />
                                    </button>
                                  )}
                                </div>
                              )}

                              {/* Morning Shift */}
                              {(editSummaryMode ||
                                morningPull !== 0 ||
                                morningCount !== 0) && (
                                <div className="das-row das-row--green">
                                  <div className="das-row-left">
                                    <span
                                      className="das-icon"
                                      role="img"
                                      aria-label="sunrise"
                                    >
                                      🌅
                                    </span>
                                    <div>
                                      <div className="das-label">
                                        Morning Shift
                                      </div>
                                      <div className="das-sub-row">
                                        <span className="das-sub-label">
                                          Pull:
                                        </span>
                                        <span className="das-sub-amount">
                                          {this.fmt(morningPull)}
                                        </span>
                                      </div>
                                      <div className="das-sub-row">
                                        <span className="das-sub-label">
                                          Customers:
                                        </span>
                                        <span className="das-sub-amount">
                                          {morningCount}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* Night Shift */}
                              {(editSummaryMode ||
                                nightPull !== 0 ||
                                nightCount !== 0) && (
                                <div className="das-row das-row--teal">
                                  <div className="das-row-left">
                                    <span
                                      className="das-icon"
                                      role="img"
                                      aria-label="moon"
                                    >
                                      🌙
                                    </span>
                                    <div>
                                      <div className="das-label">
                                        Night Shift
                                      </div>
                                      <div className="das-sub-row">
                                        <span className="das-sub-label">
                                          Pull:
                                        </span>
                                        <span className="das-sub-amount">
                                          {this.fmt(nightPull)}
                                        </span>
                                      </div>
                                      <div className="das-sub-row">
                                        <span className="das-sub-label">
                                          Customers:
                                        </span>
                                        <span className="das-sub-amount">
                                          {nightCount}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
          </div>
        )}

        <Menu
          open={Boolean(this.state.pdfPopperAnchor)}
          anchorEl={this.state.pdfPopperAnchor}
          onClose={this.handlePdfPopperClose}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            elevation: 4,
            style: {
              borderRadius: 10,
              overflow: 'hidden',
              minWidth: 180,
              marginTop: 4,
            },
          }}
        >
          {selectedDay !== 'SUMMARY' && (
            <MenuItem
              onClick={() => this.handlePdfOptionSelect('quick')}
              style={{ gap: 10, padding: '10px 16px', fontSize: 14 }}
            >
              <GetApp style={{ fontSize: 18, color: '#4f46e5' }} />
              Quick Summary (Profit)
            </MenuItem>
          )}
          {selectedDay !== 'SUMMARY' && (
            <MenuItem
              onClick={() => this.handlePdfOptionSelect('full')}
              style={{ gap: 10, padding: '10px 16px', fontSize: 14 }}
            >
              <GetApp style={{ fontSize: 18, color: '#2563eb' }} />
              Full Report (All Sections)
            </MenuItem>
          )}
          {selectedDay === 'SUMMARY' && (
            <MenuItem
              onClick={() => this.handlePdfOptionSelect('summary')}
              style={{ gap: 10, padding: '10px 16px', fontSize: 14 }}
            >
              <GetApp style={{ fontSize: 18, color: '#16a34a' }} />
              Download Summary
            </MenuItem>
          )}
        </Menu>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  loadingData: loadingSelector(state),
  report: reportSelector(state),
  summary: summarySelector(state),
  summaryBreakdown: summaryBreakdownSelector(state),
  employeeSummary: employeeSummarySelector(state),
  allSessionIds: allSessionIdsSelector(state),
  PDFPreviewReady: globalPDFPreviewReadySelector(state),
  managerSetting: managerSettingSelector(state),
  managerSummary: managerSummarySelector(state),
  shortAnalysis: shortAnalysisSelector(state),
  weeklyReportAuditLogs: weeklyReportAuditLogsSelector(state),
});

const actionCreators = {
  listReport,
  listSessionIds,
  updateReportField,
  clearWeeklyReport,
  updateManagerBank,
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
  getManagerSummary,
  saveManagerSetting,
  saveManagerSummary,
  listShortAnalysis,
  listWeeklyReportAudit,
};

export default withShipment({ actionCreators, mapStateToProps }, ReportView);
